
            //------------------------------------------------------------------------------
            // <auto-generated>
            //     This code was generated from a template.
            //
            //     Manual changes to this file may cause unexpected behavior in your application.
            //     Manual changes to this file will be overwritten if the code is regenerated.
            // </auto-generated>
            //------------------------------------------------------------------------------
        
	export enum Localization {
		 Accept = 'accept',
		 AcceptAndConfirm = 'acceptAndConfirm',
		 AcceptTheCrop = 'acceptTheCrop',
		 AccessChappsManager = 'accessChappsManager',
		 Accessibility = 'accessibility',
		 Account = 'account',
		 AccountAlreadyExistsMessage = 'accountAlreadyExistsMessage',
		 AccountConfirmation = 'accountConfirmation',
		 AccountConfirmationFailed = 'accountConfirmationFailed',
		 AccountDetails = 'accountDetails',
		 AccountExists = 'accountExists',
		 AccountInvitation = 'accountInvitation',
		 AccountNotActive = 'accountNotActive',
		 AccountNumber = 'accountNumber',
		 AccountRegistration = 'accountRegistration',
		 AccountRemoval = 'accountRemoval',
		 AccountRoles = 'accountRoles',
		 Action = 'action',
		 ActionAssignedNotification = 'actionAssignedNotification',
		 ActionAssignmentUpdatesSubject = 'actionAssignmentUpdatesSubject',
		 ActionDeletedNotification = 'actionDeletedNotification',
		 ActionDetails = 'actionDetails',
		 ActionIsIrreversible = 'actionIsIrreversible',
		 ActionLog = 'actionLog',
		 ActionLogAssigned = 'actionLogAssigned',
		 ActionLogUnassigned = 'actionLogUnassigned',
		 ActionNotAvailable = 'actionNotAvailable',
		 Actions = 'actions',
		 ActionsAssignedSubjectTitle = 'actionsAssignedSubjectTitle',
		 ActionsByType = 'actionsByType',
		 ActionsCancelledSubjectTitle = 'actionsCancelledSubjectTitle',
		 ActionsResolvedSubjectTitle = 'actionsResolvedSubjectTitle',
		 ActionsSentNotification = 'actionsSentNotification',
		 ActionStatus = 'actionStatus',
		 ActionSubStatusType_Accepted = 'actionSubStatusType_Accepted',
		 ActionSubStatusType_Assigned = 'actionSubStatusType_Assigned',
		 ActionSubStatusType_Sent = 'actionSubStatusType_Sent',
		 ActionsUnassignedSubjectTitle = 'actionsUnassignedSubjectTitle',
		 Activate = 'activate',
		 ActivateYourSubscription = 'activateYourSubscription',
		 Activation = 'activation',
		 ActivationFailed = 'activationFailed',
		 Active = 'active',
		 ActiveCard = 'activeCard',
		 ActiveCardExpirationDate = 'activeCardExpirationDate',
		 ActiveFiltersLabel = 'activeFiltersLabel',
		 ActiveSubscription = 'activeSubscription',
		 Add = 'add',
		 AddAction = 'addAction',
		 AddAdditionalSignatory = 'addAdditionalSignatory',
		 AddAnotherJob = 'addAnotherJob',
		 AddAPicture = 'addAPicture',
		 AddBuilding = 'addBuilding',
		 AddBuildingFeeInfo = 'addBuildingFeeInfo',
		 AddBuildingLayer = 'addBuildingLayer',
		 AddBuildingRole = 'addBuildingRole',
		 AddBuildings = 'addBuildings',
		 AddCheckpoint = 'addCheckpoint',
		 AddCheckpointTooltip = 'addCheckpointTooltip',
		 AddContact = 'addContact',
		 AddCustomCheckpoint = 'addCustomCheckpoint',
		 AddDirectIssueToBuilding = 'addDirectIssueToBuilding',
		 AddDocument = 'addDocument',
		 AddElement = 'addElement',
		 AddFunction = 'addFunction',
		 AddGroup = 'addGroup',
		 AddGroupTooltip = 'addGroupTooltip',
		 AddItem = 'addItem',
		 AddItemNgx = 'addItemNgx',
		 AdditionalComment = 'additionalComment',
		 AddLogin = 'addLogin',
		 AddMetersDescription = 'addMetersDescription',
		 AddNew = 'addNew',
		 AddNewBuildingEnvelope = 'addNewBuildingEnvelope',
		 AddNewCard = 'addNewCard',
		 AddNewCheckpoint = 'addNewCheckpoint',
		 AddNewCommonAreas = 'addNewCommonAreas',
		 AddNewCustomCheckpoint = 'addNewCustomCheckpoint',
		 AddNewExterior = 'addNewExterior',
		 AddNewFloors = 'addNewFloors',
		 AddNewGroup = 'addNewGroup',
		 AddNewIssue = 'addNewIssue',
		 AddNewLogin = 'addNewLogin',
		 AddNewMeter = 'addNewMeter',
		 AddNewPrivateUnits = 'addNewPrivateUnits',
		 AddNewSharedUnits = 'addNewSharedUnits',
		 AddNewUtilities = 'addNewUtilities',
		 AddPrivateUnitFeeInfo = 'addPrivateUnitFeeInfo',
		 Address = 'address',
		 AddRole = 'addRole',
		 AddSection = 'addSection',
		 AddSectionTooltip = 'addSectionTooltip',
		 AddSubstructure = 'addSubstructure',
		 AddToFavourites = 'addToFavourites',
		 AddUserFeeInfo = 'addUserFeeInfo',
		 AfterClicking = 'afterClicking',
		 Agree = 'agree',
		 AgreeContinue = 'agreeContinue',
		 Alert = 'alert',
		 All = 'all',
		 AllBuildingIssues = 'allBuildingIssues',
		 AllBuildings = 'allBuildings',
		 AllOpenBuildingIssues = 'allOpenBuildingIssues',
		 AlmostThere = 'almostThere',
		 Alphabetical = 'alphabetical',
		 AlreadyHaveAnAccount = 'alreadyHaveAnAccount',
		 Amount = 'amount',
		 AmountOfDaysLeftOnTrial = 'amountOfDaysLeftOnTrial',
		 AnActivationEmailHasBeenSent = 'anActivationEmailHasBeenSent',
		 And = 'and',
		 AnEmailWillBeSendTo = 'anEmailWillBeSendTo',
		 AnErrorOccuredWhileProcessingThePayment = 'anErrorOccuredWhileProcessingThePayment',
		 AnnotateMultimediumCommentDelete = 'annotateMultimediumCommentDelete',
		 AnnotateMultimediumCommentSave = 'annotateMultimediumCommentSave',
		 AnnotateMultimediumCommentTitle = 'annotateMultimediumCommentTitle',
		 AnnotateMultimediumDiscardChangesExitButton = 'annotateMultimediumDiscardChangesExitButton',
		 AnnotateMultimediumDiscardChangesMessage = 'annotateMultimediumDiscardChangesMessage',
		 AnnotateMultimediumDiscardChangesStayButton = 'annotateMultimediumDiscardChangesStayButton',
		 AnnotateMultimediumDiscardChangesTitle = 'annotateMultimediumDiscardChangesTitle',
		 AnnotateMultimediumStrokeColorBlack = 'annotateMultimediumStrokeColorBlack',
		 AnnotateMultimediumStrokeColorBlue = 'annotateMultimediumStrokeColorBlue',
		 AnnotateMultimediumStrokeColorGreen = 'annotateMultimediumStrokeColorGreen',
		 AnnotateMultimediumStrokeColorOrange = 'annotateMultimediumStrokeColorOrange',
		 AnnotateMultimediumStrokeColorRed = 'annotateMultimediumStrokeColorRed',
		 AnnotateMultimediumStrokeColorWhite = 'annotateMultimediumStrokeColorWhite',
		 AnnotateMultimediumStrokeColorYellow = 'annotateMultimediumStrokeColorYellow',
		 AnnotateMultimediumStrokeWeightFine = 'annotateMultimediumStrokeWeightFine',
		 AnnotateMultimediumStrokeWeightHeavy = 'annotateMultimediumStrokeWeightHeavy',
		 AnnotateMultimediumStrokeWeightNormal = 'annotateMultimediumStrokeWeightNormal',
		 AnnotateMultimediumStrokeWeightThick = 'annotateMultimediumStrokeWeightThick',
		 AnnotateMultimediumStrokeWeightThin = 'annotateMultimediumStrokeWeightThin',
		 Apartment = 'apartment',
		 Apartments = 'apartments',
		 ApiToken = 'apiToken',
		 App = 'app',
		 AppBuildNumber = 'appBuildNumber',
		 Appendix = 'appendix',
		 ApplicationHasNoReportSettingsContentToDisplay = 'applicationHasNoReportSettingsContentToDisplay',
		 ApplicationHasNoReportSettingsLayoutToDisplay = 'applicationHasNoReportSettingsLayoutToDisplay',
		 AppName = 'appName',
		 AppSync_Authenticating = 'appSync_Authenticating',
		 AppSync_Completed = 'appSync_Completed',
		 AppSync_Error = 'appSync_Error',
		 AppSync_ErrorSync = 'appSync_ErrorSync',
		 AppSync_MultimediaDownload = 'appSync_MultimediaDownload',
		 AppSync_MultimediaDownloadStart = 'appSync_MultimediaDownloadStart',
		 AppSync_MultimediaUpload = 'appSync_MultimediaUpload',
		 AppSync_OneWaySync = 'appSync_OneWaySync',
		 AppSync_StepsLabel = 'appSync_StepsLabel',
		 AppSync_TwoWaySync = 'appSync_TwoWaySync',
		 AppVersion = 'appVersion',
		 Apr = 'apr',
		 April = 'april',
		 Area = 'area',
		 AreaLabels = 'areaLabels',
		 AreYouSure = 'areYouSure',
		 AreYouSureYouWantToCancelInspection = 'areYouSureYouWantToCancelInspection',
		 AreYouSureYouWantToDelete = 'areYouSureYouWantToDelete',
		 AreYouSureYouWantToDeleteBuildingPhoto = 'areYouSureYouWantToDeleteBuildingPhoto',
		 AreYouSureYouWantToDeleteCheckpoint = 'areYouSureYouWantToDeleteCheckpoint',
		 AreYouSureYouWantToDeleteCheckpointPhoto = 'areYouSureYouWantToDeleteCheckpointPhoto',
		 AreYouSureYouWantToDeleteContactFromThisInterventionTeam = 'areYouSureYouWantToDeleteContactFromThisInterventionTeam',
		 AreYouSureYouWantToDeleteContactFunction = 'areYouSureYouWantToDeleteContactFunction',
		 AreYouSureYouWantToDeleteContactTo = 'areYouSureYouWantToDeleteContactTo',
		 AreYouSureYouWantToDeleteDocument = 'areYouSureYouWantToDeleteDocument',
		 AreYouSureYouWantToDeleteInterventionTeam = 'areYouSureYouWantToDeleteInterventionTeam',
		 AreYouSureYouWantToDeleteMeter = 'areYouSureYouWantToDeleteMeter',
		 AreYouSureYouWantToDeletePhoto = 'areYouSureYouWantToDeletePhoto',
		 AreYouSureYouWantToDeleteRole = 'areYouSureYouWantToDeleteRole',
		 AreYouSureYouWantToDeleteStructure = 'areYouSureYouWantToDeleteStructure',
		 AreYouSureYouWantToDeleteThisJob = 'areYouSureYouWantToDeleteThisJob',
		 AreYouSureYouWantToDeleteThisRole = 'areYouSureYouWantToDeleteThisRole',
		 AreYouSureYouWantToRemoveContactFromThisLocation = 'areYouSureYouWantToRemoveContactFromThisLocation',
		 Assign = 'assign',
		 AssignBoard = 'assignBoard',
		 Assigned = 'assigned',
		 AssignedTo = 'assignedTo',
		 AssignJob = 'assignJob',
		 AssignJobs = 'assignJobs',
		 Attention = 'attention',
		 AttentionPoints = 'attentionPoints',
		 AttentionPointsDescription = 'attentionPointsDescription',
		 AttentionPointsEmptyText = 'attentionPointsEmptyText',
		 Aug = 'aug',
		 August = 'august',
		 AutoAccept = 'autoAccept',
		 AutoSend = 'autoSend',
		 Back = 'back',
		 BackgroundColor = 'backgroundColor',
		 BackToPurchasePages = 'backToPurchasePages',
		 BackToStep1 = 'backToStep1',
		 BackToStep2 = 'backToStep2',
		 Basic = 'basic',
		 BirthDate = 'birthDate',
		 BlackText = 'blackText',
		 Build = 'build',
		 Building = 'building',
		 BuildingActionsHeaderStateTooltipAccepted = 'buildingActionsHeaderStateTooltipAccepted',
		 buildingActionsHeaderStateTooltipDeclined = 'buildingActionsHeaderStateTooltipDeclined',
		 BuildingActionsHeaderStateTooltipExecuting = 'buildingActionsHeaderStateTooltipExecuting',
		 BuildingActionsHeaderStateTooltipFinished = 'buildingActionsHeaderStateTooltipFinished',
		 BuildingChecklistsView = 'buildingChecklistsView',
		 BuildingDashboardView = 'buildingDashboardView',
		 BuildingDocuments = 'buildingDocuments',
		 BuildingDocumentsEmptyStateLabel = 'buildingDocumentsEmptyStateLabel',
		 BuildingEdit = 'buildingEdit',
		 BuildingEnterpriseNumber = 'buildingEnterpriseNumber',
		 BuildingEnvelope = 'buildingEnvelope',
		 BuildingHistoryView = 'buildingHistoryView',
		 BuildingInfo = 'buildingInfo',
		 BuildingInitialization = 'buildingInitialization',
		 BuildingIssuesView = 'buildingIssuesView',
		 BuildingLayer = 'buildingLayer',
		 BuildingLayers = 'buildingLayers',
		 BuildingList = 'buildingList',
		 BuildingMetersView = 'buildingMetersView',
		 BuildingName = 'buildingName',
		 BuildingOnSite = 'buildingOnSite',
		 Buildings = 'buildings',
		 BuildingsAdd = 'buildingsAdd',
		 BuildingsAndInspections = 'buildingsAndInspections',
		 BuildingsEdit = 'buildingsEdit',
		 BuildingSetup = 'buildingSetup',
		 BuildingsExplore = 'buildingsExplore',
		 BuildingsOnSite = 'buildingsOnSite',
		 BuildingStructureView = 'buildingStructureView',
		 BuildingsView = 'buildingsView',
		 BuildingUnit = 'buildingUnit',
		 Business = 'business',
		 BusinessInfo = 'businessInfo',
		 BusinessName = 'businessName',
		 BusinessNameIs = 'businessNameIs',
		 By = 'by',
		 ByTeam = 'byTeam',
		 CallContact = 'callContact',
		 Calori = 'calori',
		 Camera = 'camera',
		 CameraAccessError = 'cameraAccessError',
		 Cancel = 'cancel',
		 CanceledJobs = 'canceledJobs',
		 CancelInspectionActionDescription = 'cancelInspectionActionDescription',
		 CancelInspectionDescription = 'cancelInspectionDescription',
		 CancelInspectionOption = 'cancelInspectionOption',
		 CancelIssue = 'cancelIssue',
		 Cancelled = 'cancelled',
		 CancelledBy = 'cancelledBy',
		 CancelledOn = 'cancelledOn',
		 CancelledSubscriptionMailSubject = 'cancelledSubscriptionMailSubject',
		 CancelledSubscriptionMessage = 'cancelledSubscriptionMessage',
		 CancellingInspection = 'cancellingInspection',
		 CancelMeterReadingOption = 'cancelMeterReadingOption',
		 CancelSubscription = 'cancelSubscription',
		 CancelSubscriptionConfirmationMessage = 'cancelSubscriptionConfirmationMessage',
		 CannotDeleteInterventionTeamDueToAssignedActions = 'cannotDeleteInterventionTeamDueToAssignedActions',
		 CannotDeleteInterventionTeamMessage = 'cannotDeleteInterventionTeamMessage',
		 CannotRemoveAdminRole = 'cannotRemoveAdminRole',
		 Category = 'category',
		 ChangeExecutorStatus = 'changeExecutorStatus',
		 ChangeLanguage = 'changeLanguage',
		 ChangeStructureLabel = 'changeStructureLabel',
		 ChangeStructureSurfaceArea = 'changeStructureSurfaceArea',
		 ChappsManager = 'chappsManager',
		 Characteristics = 'characteristics',
		 CharacteristicsEmptyState = 'characteristicsEmptyState',
		 CharacteristicsFor = 'characteristicsFor',
		 CheckIfAllInformationIsCorrect = 'checkIfAllInformationIsCorrect',
		 Checklist = 'checklist',
		 ChecklistDescription = 'checklistDescription',
		 ChecklistDisabledDescription = 'checklistDisabledDescription',
		 ChecklistHasBeenCopied = 'checklistHasBeenCopied',
		 ChecklistHasBeenCopiedMultiple = 'checklistHasBeenCopiedMultiple',
		 ChecklistName = 'checklistName',
		 Checklists = 'checklists',
		 ChecklistsDescriptionBuilding = 'checklistsDescriptionBuilding',
		 ChecklistsDescriptionSite = 'checklistsDescriptionSite',
		 ChecklistsEmptyDataMessage = 'checklistsEmptyDataMessage',
		 ChecklistType = 'checklistType',
		 ChecklistType_FullAudit = 'checklistType_FullAudit',
		 ChecklistType_MaintenanceInventory = 'checklistType_MaintenanceInventory',
		 ChecklistTypeError = 'checklistTypeError',
		 Checkpoint = 'checkpoint',
		 CheckpointCascadeCurrentAndFutureDescription = 'checkpointCascadeCurrentAndFutureDescription',
		 CheckpointCascadeCurrentAndFutureTitle = 'checkpointCascadeCurrentAndFutureTitle',
		 CheckpointCascadeCurrentFutureAndExistingDescription = 'checkpointCascadeCurrentFutureAndExistingDescription',
		 CheckpointCascadeCurrentFutureAndExistingTitle = 'checkpointCascadeCurrentFutureAndExistingTitle',
		 CheckpointCascadeOnlyCurrentDescription = 'checkpointCascadeOnlyCurrentDescription',
		 CheckpointCascadeOnlyCurrentTitle = 'checkpointCascadeOnlyCurrentTitle',
		 CheckpointEvaluationProgress = 'checkpointEvaluationProgress',
		 Checkpoints = 'checkpoints',
		 CheckpointsInformation = 'checkpointsInformation',
		 CheckpointState = 'checkpointState',
		 CheckPointValueType = 'checkPointValueType',
		 CheckSpamFolder = 'checkSpamFolder',
		 CheckUp = 'checkUp',
		 CheckUpDescription = 'checkUpDescription',
		 CheckUpDisabledDescription = 'checkUpDisabledDescription',
		 CheckupInspections = 'checkupInspections',
		 ChooseBuilding = 'chooseBuilding',
		 ChooseContactBuildingFunction = 'chooseContactBuildingFunction',
		 ChooseFile = 'chooseFile',
		 ChooseRegister = 'chooseRegister',
		 ChooseRole = 'chooseRole',
		 City = 'city',
		 CityNameIs = 'cityNameIs',
		 Cleanliness = 'cleanliness',
		 Clear = 'clear',
		 ClientId = 'clientId',
		 ClientSecret = 'clientSecret',
		 Close = 'close',
		 CloseInspectionAlert = 'closeInspectionAlert',
		 CloseMeterReadingAlert = 'closeMeterReadingAlert',
		 Code = 'code',
		 ComingSoon = 'comingSoon',
		 Comment = 'comment',
		 Comments = 'comments',
		 CommercialUnits = 'commercialUnits',
		 CommonArea = 'commonArea',
		 CommonAreas = 'commonAreas',
		 CommunalMeters = 'communalMeters',
		 CommunalOnly = 'communalOnly',
		 Communications = 'communications',
		 CompactReport = 'compactReport',
		 CompactReportDescription = 'compactReportDescription',
		 Company = 'company',
		 CompanyInfo = 'companyInfo',
		 CompanyInfoLogoUploadView = 'companyInfoLogoUploadView',
		 CompanyLogo = 'companyLogo',
		 CompanyNameOrFirstNameAndLastNameAreRequired = 'companyNameOrFirstNameAndLastNameAreRequired',
		 CompanyOptional = 'companyOptional',
		 Complete = 'complete',
		 Completed = 'completed',
		 CompletedBuildingWizardText = 'completedBuildingWizardText',
		 CompletedBuildingWizardTextWithIntakePermission = 'completedBuildingWizardTextWithIntakePermission',
		 CompletedInspections = 'completedInspections',
		 CompletedJobs = 'completedJobs',
		 CompletedOn = 'completedOn',
		 CompletedSiteWizardText = 'completedSiteWizardText',
		 CompletedSiteWizardTextWithIntakePermission = 'completedSiteWizardTextWithIntakePermission',
		 CompleteFields = 'completeFields',
		 CompleteJobModal = 'completeJobModal',
		 CompleteJobsModal = 'completeJobsModal',
		 Conditions = 'conditions',
		 Confirm = 'confirm',
		 ConfirmAccount = 'confirmAccount',
		 ConfirmAccountMailSubject = 'confirmAccountMailSubject',
		 ConfirmationCodeSent = 'confirmationCodeSent',
		 ConfirmationEmailHasBeenResent = 'confirmationEmailHasBeenResent',
		 ConfirmationText = 'confirmationText',
		 ConfirmDeleteVideo = 'confirmDeleteVideo',
		 Confirmed = 'confirmed',
		 ConfirmForgotPassword = 'confirmForgotPassword',
		 ConfirmLoginForChappsBuilding = 'confirmLoginForChappsBuilding',
		 ConfirmPassword = 'confirmPassword',
		 ConfirmPasswordDoesNotMatchThePassword = 'confirmPasswordDoesNotMatchThePassword',
		 Conformity = 'conformity',
		 Conformity_safety = 'conformity_safety',
		 ConformityAndSafety = 'conformityAndSafety',
		 ConformityAndSafetyBlock = 'conformityAndSafetyBlock',
		 ConformityElementGroup = 'conformityElementGroup',
		 ConnectionRequired = 'connectionRequired',
		 Contact = 'contact',
		 ContactDetails = 'contactDetails',
		 ContactDocsSupportedFiles = 'contactDocsSupportedFiles',
		 ContactInfo = 'contactInfo',
		 ContactInfo_CollapseMessage = 'contactInfo_CollapseMessage',
		 ContactInfo_ExpandMessage = 'contactInfo_ExpandMessage',
		 ContactListEmptyText = 'contactListEmptyText',
		 Contacts = 'contacts',
		 ContactsDescription = 'contactsDescription',
		 ContactsDisabledDescription = 'contactsDisabledDescription',
		 ContactsEdit = 'contactsEdit',
		 ContactsOfTheBuilding = 'contactsOfTheBuilding',
		 ContactsTabDescriptionBuilding = 'contactsTabDescriptionBuilding',
		 ContactsTabDescriptionSite = 'contactsTabDescriptionSite',
		 ContactsView = 'contactsView',
		 ContainsIssues = 'containsIssues',
		 Content = 'content',
		 Continue = 'continue',
		 ContinueBuildingInspectionDescription = 'continueBuildingInspectionDescription',
		 ContinueBuildingInspectionOption = 'continueBuildingInspectionOption',
		 ContinueConfiguring = 'continueConfiguring',
		 ContinueInspectionDescription = 'continueInspectionDescription',
		 ContinueInspectionOption = 'continueInspectionOption',
		 ContinueMeterReadingDescription = 'continueMeterReadingDescription',
		 ContinueMeterReadingLaterActionDescription = 'continueMeterReadingLaterActionDescription',
		 ContinueMeterReadingLaterDescription = 'continueMeterReadingLaterDescription',
		 ContinueMeterReadingLaterOption = 'continueMeterReadingLaterOption',
		 ContinueMeterReadingOption = 'continueMeterReadingOption',
		 Copy = 'copy',
		 CopyAddressFromBuilding = 'copyAddressFromBuilding',
		 CopyAddressFromSite = 'copyAddressFromSite',
		 CopyBuilding = 'copyBuilding',
		 CopyChecklist = 'copyChecklist',
		 CopyChecklistBuilding = 'copyChecklistBuilding',
		 CopyChecklistNote = 'copyChecklistNote',
		 CopyChecklistTooltip = 'copyChecklistTooltip',
		 CopyFromObservation = 'copyFromObservation',
		 CopyItem = 'copyItem',
		 CopyOf = 'copyOf',
		 CopySite = 'copySite',
		 CopyStructurePopup = 'copyStructurePopup',
		 Country = 'country',
		 CountryIs = 'countryIs',
		 Create = 'create',
		 CreateAnAccount = 'createAnAccount',
		 CreateAnInspection = 'createAnInspection',
		 CreateBuildingDoneHint = 'createBuildingDoneHint',
		 CreateBuildingStructuresHint = 'createBuildingStructuresHint',
		 CreateCheckpoint = 'createCheckpoint',
		 CreateCopyOfStructure = 'createCopyOfStructure',
		 CreateCustomCheckpoint = 'createCustomCheckpoint',
		 Created = 'created',
		 CreatedBy = 'createdBy',
		 CreateDocument = 'createDocument',
		 CreatedOn = 'createdOn',
		 CreateEditChecklist = 'createEditChecklist',
		 CreateEditChecklistDescription = 'createEditChecklistDescription',
		 CreateFromExistingContact = 'createFromExistingContact',
		 CreateItem = 'createItem',
		 CreateLogin = 'createLogin',
		 CreateNCopiesOfStructure = 'createNCopiesOfStructure',
		 CreateNewChecklist = 'createNewChecklist',
		 CreateNewContact = 'createNewContact',
		 CreateNewInspection = 'createNewInspection',
		 CreateNewInterventionTeam = 'createNewInterventionTeam',
		 CreateNode = 'createNode',
		 CreatePluralCopyOfStructure = 'createPluralCopyOfStructure',
		 CreateSingleCopyOfStructure = 'createSingleCopyOfStructure',
		 CreateSiteDoneHint = 'createSiteDoneHint',
		 CreditsDescription = 'creditsDescription',
		 CreditsLeft = 'creditsLeft',
		 CreditsLeftTrial = 'creditsLeftTrial',
		 CreditsRemaining = 'creditsRemaining',
		 CropAllImagesAutomatically = 'cropAllImagesAutomatically',
		 CropImagesBeforeUpload = 'cropImagesBeforeUpload',
		 CurrentProvider = 'currentProvider',
		 CustomDeviceName = 'customDeviceName',
		 CustomerInfo = 'customerInfo',
		 CustomisePredefinedChecklistHeader = 'customisePredefinedChecklistHeader',
		 CustomisePredefinedChecklistText = 'customisePredefinedChecklistText',
		 Damage = 'damage',
		 Dashboard = 'dashboard',
		 DashboardDescriptionBuilding = 'dashboardDescriptionBuilding',
		 DashboardDescriptionSite = 'dashboardDescriptionSite',
		 Date = 'date',
		 DateOfBirth = 'dateOfBirth',
		 Day = 'day',
		 Deactivate = 'deactivate',
		 Dec = 'dec',
		 December = 'december',
		 Degradation = 'degradation',
		 Delete = 'delete',
		 DeleteAccount = 'deleteAccount',
		 DeleteAccountAlert = 'deleteAccountAlert',
		 DeleteAccountDescription = 'deleteAccountDescription',
		 DeleteBuilding = 'deleteBuilding',
		 DeleteChecklist = 'deleteChecklist',
		 DeleteCheckpoint = 'deleteCheckpoint',
		 DeleteCheckpointCascadeDialogCancel = 'deleteCheckpointCascadeDialogCancel',
		 DeleteCheckpointCascadeDialogConfirm = 'deleteCheckpointCascadeDialogConfirm',
		 DeleteCheckpointCascadeDialogMessage = 'deleteCheckpointCascadeDialogMessage',
		 DeleteCheckpointCascadeDialogTitle = 'deleteCheckpointCascadeDialogTitle',
		 DeleteCheckpointCascadeWarningDialogConfirm = 'deleteCheckpointCascadeWarningDialogConfirm',
		 DeleteCheckpointCascadeWarningDialogMessage = 'deleteCheckpointCascadeWarningDialogMessage',
		 DeleteCheckpointCascadeWarningDialogTitle = 'deleteCheckpointCascadeWarningDialogTitle',
		 DeleteContact = 'deleteContact',
		 DeleteContactFailedDueToExistingLinkedFunctions = 'deleteContactFailedDueToExistingLinkedFunctions',
		 DeleteContactFailedDueToExistingLinkedInterventionTeams = 'deleteContactFailedDueToExistingLinkedInterventionTeams',
		 DeleteContactFailedDueToLoginAssigned = 'deleteContactFailedDueToLoginAssigned',
		 DeleteContactMessage = 'deleteContactMessage',
		 DeleteExecutor = 'deleteExecutor',
		 DeleteExecutorConfirmation = 'deleteExecutorConfirmation',
		 DeleteExecutorTooltip = 'deleteExecutorTooltip',
		 DeleteItem = 'deleteItem',
		 DeleteJob = 'deleteJob',
		 DeleteJobs = 'deleteJobs',
		 DeleteJobWarningMessage = 'deleteJobWarningMessage',
		 DeleteReminderCTA = 'deleteReminderCTA',
		 DeleteSection = 'deleteSection',
		 DeleteSite = 'deleteSite',
		 DeleteStructure = 'deleteStructure',
		 DeleteStructureConfirmation = 'deleteStructureConfirmation',
		 DeleteTeam = 'deleteTeam',
		 DeleteTeamMessage = 'deleteTeamMessage',
		 DemoHasExpiredEmailSubject = 'demoHasExpiredEmailSubject',
		 DemoSubscription = 'demoSubscription',
		 DemoSubscriptionWillExpireAt = 'demoSubscriptionWillExpireAt',
		 DependingOnYourChoiceAndDataWeWillProcess = 'dependingOnYourChoiceAndDataWeWillProcess',
		 Description = 'description',
		 Details = 'details',
		 Detected = 'detected',
		 Device = 'device',
		 DeviceLogIsEmpty = 'deviceLogIsEmpty',
		 DeviceName = 'deviceName',
		 Devices = 'devices',
		 DevicesView = 'devicesView',
		 DeviceTokensDontMatch = 'deviceTokensDontMatch',
		 DeviceType = 'deviceType',
		 DidntReceiveMail = 'didntReceiveMail',
		 DirectIssue = 'directIssue',
		 Directive = 'directive',
		 Dirty = 'dirty',
		 Disability = 'disability',
		 DisabledContactsAreExistingAccounts = 'disabledContactsAreExistingAccounts',
		 Discard = 'discard',
		 Discount = 'discount',
		 DisplayContactInResidenzManager = 'displayContactInResidenzManager',
		 Document = 'document',
		 DocumentListEmptyText = 'documentListEmptyText',
		 Documents = 'documents',
		 DocumentsDescriptionBuilding = 'documentsDescriptionBuilding',
		 DocumentsDescriptionSite = 'documentsDescriptionSite',
		 DocumentsDisabledDescription = 'documentsDisabledDescription',
		 DocumentsEdit = 'documentsEdit',
		 DocumentsView = 'documentsView',
		 Done = 'done',
		 DontShowMessage = 'dontShowMessage',
		 Download = 'download',
		 DownloadAppText = 'downloadAppText',
		 DownloadAppTitle = 'downloadAppTitle',
		 DownloadGdpr = 'downloadGdpr',
		 DownloadImages = 'downloadImages',
		 DownloadReport = 'downloadReport',
		 DownloadStateOfBuilding = 'downloadStateOfBuilding',
		 DropDownActions = 'dropDownActions',
		 DueDate = 'dueDate',
		 Duplicate = 'duplicate',
		 DuplicateCheckpoint = 'duplicateCheckpoint',
		 DuplicateGroup = 'duplicateGroup',
		 DuplicateItem = 'duplicateItem',
		 DuplicateSection = 'duplicateSection',
		 DuplicateStructureMessage = 'duplicateStructureMessage',
		 DuplicateStructureTitle = 'duplicateStructureTitle',
		 DuplicationMessage = 'duplicationMessage',
		 DuplicationPerformanceWarning = 'duplicationPerformanceWarning',
		 DuplicationProgressMessage = 'duplicationProgressMessage',
		 Duration = 'duration',
		 During = 'during',
		 DuringInspectionOfType = 'duringInspectionOfType',
		 Ean = 'ean',
		 Edit = 'edit',
		 EditAction = 'editAction',
		 EditBuildingRole = 'editBuildingRole',
		 EditChecklist = 'editChecklist',
		 EditChecklistType = 'editChecklistType',
		 EditCheckpoint = 'editCheckpoint',
		 EditCheckpointCascadeWarningDialogConfirm = 'editCheckpointCascadeWarningDialogConfirm',
		 EditCheckpointCascadeWarningDialogMessage = 'editCheckpointCascadeWarningDialogMessage',
		 EditCheckpointCascadeWarningDialogTitle = 'editCheckpointCascadeWarningDialogTitle',
		 EditCheckpoints = 'editCheckpoints',
		 EditContact = 'editContact',
		 EditDetails = 'editDetails',
		 EditDocument = 'editDocument',
		 EditElement = 'editElement',
		 EditElements = 'editElements',
		 EditEmail = 'editEmail',
		 EditGroup = 'editGroup',
		 EditInfo = 'editInfo',
		 EditInspection = 'editInspection',
		 EditInspectionDescription = 'editInspectionDescription',
		 EditIssueDetails = 'editIssueDetails',
		 EditItem = 'editItem',
		 EditJobs = 'editJobs',
		 EditLabels = 'editLabels',
		 EditMeterDetails = 'editMeterDetails',
		 EditNodeLabel = 'editNodeLabel',
		 EditOnTheGo = 'editOnTheGo',
		 EditSection = 'editSection',
		 Electricity = 'electricity',
		 ElectricityNightExclusive = 'electricityNightExclusive',
		 ElectricityOffPeak = 'electricityOffPeak',
		 ElectricityPeak = 'electricityPeak',
		 Element = 'element',
		 ElementCategory = 'elementCategory',
		 Elements = 'elements',
		 ElementsInformation = 'elementsInformation',
		 Email = 'email',
		 EmailAddressAlreadyConfirmed = 'emailAddressAlreadyConfirmed',
		 EmailHasBeenSendTo = 'emailHasBeenSendTo',
		 EmailIs = 'emailIs',
		 EmailIsIncorrect = 'emailIsIncorrect',
		 EmailNotValid = 'emailNotValid',
		 EmailNotValidMessage = 'emailNotValidMessage',
		 EmailTaken = 'emailTaken',
		 EmailUnknown = 'emailUnknown',
		 Empty = 'empty',
		 EmptyAcceptedJobsColumnMessage = 'emptyAcceptedJobsColumnMessage',
		 EmptyAssignedJobsColumnMessage = 'emptyAssignedJobsColumnMessage',
		 EmptyCheckPoints = 'emptyCheckPoints',
		 EmptyDataMessage = 'emptyDataMessage',
		 emptyDeclinedJobsColumnMessage = 'emptyDeclinedJobsColumnMessage',
		 EmptyDefaultJobsBuildingsListMessage = 'emptyDefaultJobsBuildingsListMessage',
		 EmptyDefaultJobsNoBuildingSelectedMessage = 'emptyDefaultJobsNoBuildingSelectedMessage',
		 EmptyDefaultJobsViewNoBuildingsMessage = 'emptyDefaultJobsViewNoBuildingsMessage',
		 EmptyExecutingJobsColumnMessage = 'emptyExecutingJobsColumnMessage',
		 EmptyFinishedJobsColumnMessage = 'emptyFinishedJobsColumnMessage',
		 EmptyInterventionTeamJobsViewMessage = 'emptyInterventionTeamJobsViewMessage',
		 EmptyInterventionTeamsViewInstruction = 'emptyInterventionTeamsViewInstruction',
		 EmptyInterventionTeamsViewMessage = 'emptyInterventionTeamsViewMessage',
		 EmptyIssuesViewMessage = 'emptyIssuesViewMessage',
		 EmptyJobsInterventionTeamsListMessage = 'emptyJobsInterventionTeamsListMessage',
		 EmptyJobsInterventionTeamsViewInstruction = 'emptyJobsInterventionTeamsViewInstruction',
		 EmptyLayerMessage = 'emptyLayerMessage',
		 EmptyProcessingScreenMessage = 'emptyProcessingScreenMessage',
		 EmptyStateBuildingsMessage = 'emptyStateBuildingsMessage',
		 EmptyStateContactsMessage = 'emptyStateContactsMessage',
		 EmptyStateJobsTableMessage = 'emptyStateJobsTableMessage',
		 EmptyStateMediaMessage = 'emptyStateMediaMessage',
		 EmptyStateUnitsMessage = 'emptyStateUnitsMessage',
		 EmptyTeamAcceptedJobsColumnMessage = 'emptyTeamAcceptedJobsColumnMessage',
		 EmptyTeamRequestedJobsColumnMessage = 'emptyTeamRequestedJobsColumnMessage',
		 EmptyUnassignedJobsColumnMessage = 'emptyUnassignedJobsColumnMessage',
		 EnergyReport = 'energyReport',
		 EnterNewAccountEmailAddress = 'enterNewAccountEmailAddress',
		 EnterSixDigitCode = 'enterSixDigitCode',
		 EnterValidActivationCode = 'enterValidActivationCode',
		 Equipment = 'equipment',
		 ErrorAdditionalInformation = 'errorAdditionalInformation',
		 ErrorDetails = 'errorDetails',
		 ErrorHeader = 'errorHeader',
		 ErrorMessage = 'errorMessage',
		 Errors = 'errors',
		 ErrorSubheader = 'errorSubheader',
		 ErrorTypeHttp = 'errorTypeHttp',
		 ErrorTypeInternal = 'errorTypeInternal',
		 EvaluatedCheckpoints = 'evaluatedCheckpoints',
		 Evaluation = 'evaluation',
		 Executed = 'executed',
		 ExecutedBy = 'executedBy',
		 ExecutedInspections = 'executedInspections',
		 ExecutedOn = 'executedOn',
		 ExecutedOnPlannedOn = 'executedOnPlannedOn',
		 Executing = 'executing',
		 Executor = 'executor',
		 ExecutorAddedOn = 'executorAddedOn',
		 ExecutorEmailMissing = 'executorEmailMissing',
		 ExecutorName = 'executorName',
		 ExecutorNameMissing = 'executorNameMissing',
		 ExecutorNoJobs = 'executorNoJobs',
		 ExecutorNotAddedMessage = 'executorNotAddedMessage',
		 Executors = 'executors',
		 ExecutorStatus = 'executorStatus',
		 ExistingIssues = 'existingIssues',
		 ExitApplication = 'exitApplication',
		 ExpirationDate = 'expirationDate',
		 ExpiredDemoSubscriptionMailSubject = 'expiredDemoSubscriptionMailSubject',
		 Export = 'export',
		 ExportIssues = 'exportIssues',
		 ExportIssuesOptions = 'exportIssuesOptions',
		 ExportMeters = 'exportMeters',
		 ExportMetersOptions = 'exportMetersOptions',
		 ExportSelected = 'exportSelected',
		 Ext = 'ext',
		 ExtendYourSubscriptionNow = 'extendYourSubscriptionNow',
		 Exterior = 'exterior',
		 ExteriorElement = 'exteriorElement',
		 ExtraBuildings = 'extraBuildings',
		 ExtraUsers = 'extraUsers',
		 FailedPaymentMessage = 'failedPaymentMessage',
		 Fax = 'fax',
		 FeatureNotActivated = 'featureNotActivated',
		 FeatureNotActivatedDescription = 'featureNotActivatedDescription',
		 Feb = 'feb',
		 February = 'february',
		 Feedback = 'feedback',
		 FeedbackMessage = 'feedbackMessage',
		 FeedbackMultimedia = 'feedbackMultimedia',
		 FeedbackSubmitted = 'feedbackSubmitted',
		 FeedbackSuccess = 'feedbackSuccess',
		 FeedbackTitle = 'feedbackTitle',
		 FileOverSizeLimit = 'fileOverSizeLimit',
		 FillOutTheAddress = 'fillOutTheAddress',
		 Filter = 'filter',
		 FilterAndSortActions = 'filterAndSortActions',
		 FilterAndSortCheckpoints = 'filterAndSortCheckpoints',
		 FilterAndSortIssues = 'filterAndSortIssues',
		 FilterAndSortMeters = 'filterAndSortMeters',
		 FilterBuildings = 'filterBuildings',
		 FilterBy = 'filterBy',
		 FilterInspections = 'filterInspections',
		 FilterIssuesBy = 'filterIssuesBy',
		 Filters = 'filters',
		 Finish = 'finish',
		 FinishAndConfigureMessage = 'finishAndConfigureMessage',
		 FinishAndStartIntakeMessage = 'finishAndStartIntakeMessage',
		 Finished = 'finished',
		 FinishedOn = 'finishedOn',
		 Finishing = 'finishing',
		 FinishingBlock = 'finishingBlock',
		 FinishInspection = 'finishInspection',
		 FinishInspectionActionDescription = 'finishInspectionActionDescription',
		 FinishInspectionAlert = 'finishInspectionAlert',
		 FinishInspectionDescription = 'finishInspectionDescription',
		 FinishInspectionOption = 'finishInspectionOption',
		 FinishMeterReadingOption = 'finishMeterReadingOption',
		 FirstName = 'firstName',
		 FirstNameIs = 'firstNameIs',
		 FirstSync = 'firstSync',
		 Floor = 'floor',
		 FloorplanViewIssueCTA = 'floorplanViewIssueCTA',
		 Floors = 'floors',
		 Font = 'font',
		 For = 'for',
		 ForbiddenDetails = 'forbiddenDetails',
		 ForbiddenHeader = 'forbiddenHeader',
		 ForbiddenManagerRequiredDetails = 'forbiddenManagerRequiredDetails',
		 ForbiddenManagerRequiredHeader = 'forbiddenManagerRequiredHeader',
		 ForgotPassword = 'forgotPassword',
		 ForgotPasswordDetailMessage = 'forgotPasswordDetailMessage',
		 ForgotPasswordError = 'forgotPasswordError',
		 ForgotPasswordErrorMessage = 'forgotPasswordErrorMessage',
		 ForgotPasswordMailSubject = 'forgotPasswordMailSubject',
		 ForgotPasswordMessage = 'forgotPasswordMessage',
		 ForTheseServicesAMonthlySubscriptionIsCharged = 'forTheseServicesAMonthlySubscriptionIsCharged',
		 ForTheseServicesAYearlySubscriptionIsCharged = 'forTheseServicesAYearlySubscriptionIsCharged',
		 FreeTrialActive = 'freeTrialActive',
		 FreeTrialBody = 'freeTrialBody',
		 Fri = 'fri',
		 Friday = 'friday',
		 From = 'from',
		 FullName = 'fullName',
		 FullReport = 'fullReport',
		 FullReportDescription = 'fullReportDescription',
		 Function = 'function',
		 Functionality = 'functionality',
		 Functions = 'functions',
		 Furniture = 'furniture',
		 Gas = 'gas',
		 GDPR_ContactDocumentDescription = 'gDPR_ContactDocumentDescription',
		 GDPR_ContactDocumentTitle = 'gDPR_ContactDocumentTitle',
		 GDPR_PrivacyCommisionText = 'gDPR_PrivacyCommisionText',
		 GDPRLegalText = 'gDPRLegalText',
		 Gender = 'gender',
		 General = 'general',
		 GeneralIssue = 'generalIssue',
		 GenerateApiToken = 'generateApiToken',
		 GenerateIssueReport = 'generateIssueReport',
		 GenerateReport = 'generateReport',
		 GenerateReports = 'generateReports',
		 GenerateStateOfBuilding = 'generateStateOfBuilding',
		 GenericPopoverQuestion = 'genericPopoverQuestion',
		 GetStarted = 'getStarted',
		 GoBackToLogin = 'goBackToLogin',
		 GoToBuildingMonitor = 'goToBuildingMonitor',
		 GoToChappsManager = 'goToChappsManager',
		 GoToDashboard = 'goToDashboard',
		 GoToRegisterScreen = 'goToRegisterScreen',
		 GPSLocation = 'gPSLocation',
		 Group = 'group',
		 GroupLabel = 'groupLabel',
		 Help = 'help',
		 Helpdesk = 'helpdesk',
		 Here = 'here',
		 HidePremium = 'hidePremium',
		 HideProPremium = 'hideProPremium',
		 History = 'history',
		 Hour = 'hour',
		 HouseNumber = 'houseNumber',
		 HouseNumberExtension = 'houseNumberExtension',
		 Humidity = 'humidity',
		 IAmSorry = 'iAmSorry',
		 IdCardNumber = 'idCardNumber',
		 Identification = 'identification',
		 IDontHaveAVatNumber = 'iDontHaveAVatNumber',
		 IHaveAVatNumber = 'iHaveAVatNumber',
		 IHaveReadAndAgreeToTheLicenseAgreementAbove = 'iHaveReadAndAgreeToTheLicenseAgreementAbove',
		 Image = 'image',
		 Import = 'import',
		 ImportContactsSuccessMsg = 'importContactsSuccessMsg',
		 ImportExport = 'importExport',
		 ImportMeters = 'importMeters',
		 ImportMetersSuccessMsg = 'importMetersSuccessMsg',
		 ImportPreview = 'importPreview',
		 ImportValidationStatus_InvalidFile = 'importValidationStatus_InvalidFile',
		 ImportValidationStatus_MissingColumn = 'importValidationStatus_MissingColumn',
		 ImportValidationStatus_NoData = 'importValidationStatus_NoData',
		 ImportValidationStatus_Unspecified = 'importValidationStatus_Unspecified',
		 Inactive = 'inactive',
		 InactiveSubscriptionMessage = 'inactiveSubscriptionMessage',
		 InAppPurchasesOnlyHeader = 'inAppPurchasesOnlyHeader',
		 InAppPurchasesOnlyText = 'inAppPurchasesOnlyText',
		 IncidentList = 'incidentList',
		 IncludeInReport = 'includeInReport',
		 IncludeIssuesAppendix = 'includeIssuesAppendix',
		 IncorrectPassword = 'incorrectPassword',
		 Info = 'info',
		 Information = 'information',
		 InformationTitle = 'informationTitle',
		 InOrderToAddLoginEmailIsRequired = 'inOrderToAddLoginEmailIsRequired',
		 Inspect = 'inspect',
		 InspectDescription = 'inspectDescription',
		 InspectDisabledDescription = 'inspectDisabledDescription',
		 Inspection = 'inspection',
		 InspectionAssignExecutor = 'inspectionAssignExecutor',
		 InspectionCheckPoints = 'inspectionCheckPoints',
		 InspectionComment = 'inspectionComment',
		 InspectionCouldntBeFinished = 'inspectionCouldntBeFinished',
		 InspectionDate = 'inspectionDate',
		 InspectionDetails = 'inspectionDetails',
		 InspectionFinished = 'inspectionFinished',
		 InspectionImages = 'inspectionImages',
		 InspectionIssues = 'inspectionIssues',
		 InspectionListEmptyText = 'inspectionListEmptyText',
		 InspectionMetrics = 'inspectionMetrics',
		 InspectionPerformedDetails = 'inspectionPerformedDetails',
		 InspectionReport = 'inspectionReport',
		 InspectionReportGenerationFailed = 'inspectionReportGenerationFailed',
		 InspectionReportGenerationStarted = 'inspectionReportGenerationStarted',
		 InspectionReportGenerationSucceeded = 'inspectionReportGenerationSucceeded',
		 Inspections = 'inspections',
		 InspectionsDescription = 'inspectionsDescription',
		 InspectionsEdit = 'inspectionsEdit',
		 InspectionsExecuteChecklist = 'inspectionsExecuteChecklist',
		 InspectionsExecuteCheckUp = 'inspectionsExecuteCheckUp',
		 InspectionsExecuteInspect = 'inspectionsExecuteInspect',
		 InspectionsExecuteIntake = 'inspectionsExecuteIntake',
		 InspectionsExecuteJanitor = 'inspectionsExecuteJanitor',
		 InspectionsExecuteMeterReading = 'inspectionsExecuteMeterReading',
		 InspectionsExecuteQuickAudit = 'inspectionsExecuteQuickAudit',
		 InspectionsExecuteQuickAuditLite = 'inspectionsExecuteQuickAuditLite',
		 InspectionsExecuteSystems = 'inspectionsExecuteSystems',
		 InspectionsView = 'inspectionsView',
		 InspectionType = 'inspectionType',
		 Inspector = 'inspector',
		 Instructions = 'instructions',
		 IntakeDescription = 'intakeDescription',
		 Integrity = 'integrity',
		 Intervention = 'intervention',
		 Interventions = 'interventions',
		 InterventionTeam = 'interventionTeam',
		 InterventionTeamActionsTooltip = 'interventionTeamActionsTooltip',
		 InterventionTeams = 'interventionTeams',
		 InterventionTeamsMissingEmailWarning = 'interventionTeamsMissingEmailWarning',
		 InvalidCredentials = 'invalidCredentials',
		 InvalidDate = 'invalidDate',
		 InvalidEmail = 'invalidEmail',
		 InvalidEntries = 'invalidEntries',
		 InvalidMailbox = 'invalidMailbox',
		 InvalidReminderTimeDelayError = 'invalidReminderTimeDelayError',
		 Invoice = 'invoice',
		 InvoiceEmail = 'invoiceEmail',
		 InvoiceEmailSubject = 'invoiceEmailSubject',
		 InvoiceNumber = 'invoiceNumber',
		 Involved = 'involved',
		 Issue = 'issue',
		 IssueCategory = 'issueCategory',
		 IssueDetails = 'issueDetails',
		 IssueList = 'issueList',
		 IssueListEmptyText = 'issueListEmptyText',
		 IssueLocationInfo = 'issueLocationInfo',
		 IssueLog = 'issueLog',
		 IssueMergeError = 'issueMergeError',
		 IssueModificationInfo = 'issueModificationInfo',
		 IssueObserverAndInspectionInfo = 'issueObserverAndInspectionInfo',
		 IssueObserverInfo = 'issueObserverInfo',
		 IssueOn = 'issueOn',
		 IssuePresent = 'issuePresent',
		 IssueReport = 'issueReport',
		 IssueReportDescription = 'issueReportDescription',
		 IssueResolve = 'issueResolve',
		 IssueResolvedNotification = 'issueResolvedNotification',
		 Issues = 'issues',
		 IssuesAssignContractor = 'issuesAssignContractor',
		 IssuesByCategory = 'issuesByCategory',
		 IssuesDescriptionBuilding = 'issuesDescriptionBuilding',
		 IssuesDescriptionSite = 'issuesDescriptionSite',
		 IssuesOn = 'issuesOn',
		 IssuesPresent = 'issuesPresent',
		 IssuesReport = 'issuesReport',
		 IssueStatus = 'issueStatus',
		 IssueStatusChangedNotification = 'issueStatusChangedNotification',
		 IssueSubtype = 'issueSubtype',
		 IssueSummaryFilter_AllOpen = 'issueSummaryFilter_AllOpen',
		 IssueSummaryFilter_DuringInspecion = 'issueSummaryFilter_DuringInspecion',
		 IssueType = 'issueType',
		 Jan = 'jan',
		 JanitorDescription = 'janitorDescription',
		 JanitorDisabledDescription = 'janitorDisabledDescription',
		 January = 'january',
		 Job = 'job',
		 JobAssignedOn = 'jobAssignedOn',
		 JobFor = 'jobFor',
		 JobLog = 'jobLog',
		 Jobs = 'jobs',
		 JobSent = 'jobSent',
		 JobsResolved = 'jobsResolved',
		 JobsSent = 'jobsSent',
		 JobStatus = 'jobStatus',
		 JobType = 'jobType',
		 Jul = 'jul',
		 July = 'july',
		 Jun = 'jun',
		 June = 'june',
		 KindOfProblem = 'kindOfProblem',
		 Label = 'label',
		 Language = 'language',
		 Language_DE = 'language_DE',
		 Language_EN = 'language_EN',
		 Language_ES = 'language_ES',
		 Language_FR = 'language_FR',
		 Language_HU = 'language_HU',
		 Language_IT = 'language_IT',
		 Language_NL = 'language_NL',
		 LanguageIs = 'languageIs',
		 Last = 'last',
		 LastInspection = 'lastInspection',
		 LastInspections = 'lastInspections',
		 LastLogin = 'lastLogin',
		 LastModifiedBy = 'lastModifiedBy',
		 LastName = 'lastName',
		 LastNameIs = 'lastNameIs',
		 LastPayment = 'lastPayment',
		 LastSync = 'lastSync',
		 LastSynced = 'lastSynced',
		 Later = 'later',
		 Latest = 'latest',
		 LatestInspections = 'latestInspections',
		 LatestIssues = 'latestIssues',
		 Layout = 'layout',
		 LCD = 'lCD',
		 Level = 'level',
		 Library = 'library',
		 LicenseAgreement = 'licenseAgreement',
		 LicenseAgreementUrl = 'licenseAgreementUrl',
		 LicenseNotAgreed = 'licenseNotAgreed',
		 LicenseScrollToBottom = 'licenseScrollToBottom',
		 LinkedJobs = 'linkedJobs',
		 LinkedToAllBuildings = 'linkedToAllBuildings',
		 LinkedToPrivateUnit = 'linkedToPrivateUnit',
		 Lite = 'lite',
		 LitePaymentReportCreditDescription = 'litePaymentReportCreditDescription',
		 LivingUnit = 'livingUnit',
		 LivingUnits = 'livingUnits',
		 Loading = 'loading',
		 LoadMore = 'loadMore',
		 Location = 'location',
		 LocationArea = 'locationArea',
		 LocationFloor = 'locationFloor',
		 Locations = 'locations',
		 Log = 'log',
		 Logbook = 'logbook',
		 Login = 'login',
		 LoginAlreadyConfirmed = 'loginAlreadyConfirmed',
		 LoginFailed = 'loginFailed',
		 LoginInTheChappsManager = 'loginInTheChappsManager',
		 LoginPopupTitle = 'loginPopupTitle',
		 Logins = 'logins',
		 LoginsDetails = 'loginsDetails',
		 LoginToYourAccount = 'loginToYourAccount',
		 Logo = 'logo',
		 LogoDescription = 'logoDescription',
		 Logout = 'logout',
		 LogoutFailed = 'logoutFailed',
		 LogoutWarning = 'logoutWarning',
		 Mailbox = 'mailbox',
		 MailContact = 'mailContact',
		 MailSent = 'mailSent',
		 Maintenance = 'maintenance',
		 MaintenanceAll = 'maintenanceAll',
		 MaintenanceBlock = 'maintenanceBlock',
		 MaintenanceCancel = 'maintenanceCancel',
		 MaintenanceComplete = 'maintenanceComplete',
		 MaintenanceDescription = 'maintenanceDescription',
		 MaintenanceDetails = 'maintenanceDetails',
		 MaintenanceDetailTitle = 'maintenanceDetailTitle',
		 MaintenanceExecute = 'maintenanceExecute',
		 MaintenanceHeader = 'maintenanceHeader',
		 MaintenanceTodo = 'maintenanceTodo',
		 MaintenanceView = 'maintenanceView',
		 MakeMultipleCopies = 'makeMultipleCopies',
		 Manager = 'manager',
		 ManagerBuildingChecklistsView = 'managerBuildingChecklistsView',
		 ManagerBuildingIssuesView = 'managerBuildingIssuesView',
		 ManagerBuildingMetersView = 'managerBuildingMetersView',
		 ManagerBuildingStructureView = 'managerBuildingStructureView',
		 ManageSubscription = 'manageSubscription',
		 Mandatory = 'mandatory',
		 MandatoryCheckpoints = 'mandatoryCheckpoints',
		 MandatoryCheckpointsDescription = 'mandatoryCheckpointsDescription',
		 MandatoryCheckpointsError = 'mandatoryCheckpointsError',
		 Mar = 'mar',
		 March = 'march',
		 Markings = 'markings',
		 Materials = 'materials',
		 MaximumUploadFileSize = 'maximumUploadFileSize',
		 MaxLengthAllowedIs = 'maxLengthAllowedIs',
		 May = 'may',
		 Media = 'media',
		 MediaLogImageAddedPlural = 'mediaLogImageAddedPlural',
		 MediaLogImageAddedSingular = 'mediaLogImageAddedSingular',
		 mediaLogImageDeletedPlural = 'mediaLogImageDeletedPlural',
		 mediaLogImageDeletedSingular = 'mediaLogImageDeletedSingular',
		 MergeIssues = 'mergeIssues',
		 Messages = 'messages',
		 Meter = 'meter',
		 MeterAddedNotification = 'meterAddedNotification',
		 MeterListEmptyText = 'meterListEmptyText',
		 MeterLocation = 'meterLocation',
		 MeterMultimedia = 'meterMultimedia',
		 MeterReading = 'meterReading',
		 MeterReadingDescription = 'meterReadingDescription',
		 MeterReadingDisabledDescription = 'meterReadingDisabledDescription',
		 MeterReadingFailed = 'meterReadingFailed',
		 MeterReadings = 'meterReadings',
		 Meters = 'meters',
		 MetersDescription = 'metersDescription',
		 MetersReportDescription = 'metersReportDescription',
		 Metrics = 'metrics',
		 Minute = 'minute',
		 Missing = 'missing',
		 MissingColumnsImportErrorMsg = 'missingColumnsImportErrorMsg',
		 MissingPdfViewerMessage = 'missingPdfViewerMessage',
		 MissingPdfViewerTitle = 'missingPdfViewerTitle',
		 MobileWarning = 'mobileWarning',
		 Model = 'model',
		 Mon = 'mon',
		 Monday = 'monday',
		 Month = 'month',
		 Monthly = 'monthly',
		 Months = 'months',
		 More = 'more',
		 MoveDown = 'moveDown',
		 MoveUp = 'moveUp',
		 MultimediumTypeNotSupported = 'multimediumTypeNotSupported',
		 Multiple = 'multiple',
		 MultipleMediaAddedNotification = 'multipleMediaAddedNotification',
		 MultipleMediaDeletedNotification = 'multipleMediaDeletedNotification',
		 Multiselect = 'multiselect',
		 Name = 'name',
		 NationalIdentificationNumber = 'nationalIdentificationNumber',
		 NavigateToMaintenance = 'navigateToMaintenance',
		 NavigateToResidentzNotification = 'navigateToResidentzNotification',
		 Negative = 'negative',
		 NegativeCheckpoints = 'negativeCheckpoints',
		 NegativeValueLabel = 'negativeValueLabel',
		 NewAccount = 'newAccount',
		 NewActivationCodeSent = 'newActivationCodeSent',
		 NewBuilding = 'newBuilding',
		 NewBuildingCreated = 'newBuildingCreated',
		 NewBuildingInspectionDescription = 'newBuildingInspectionDescription',
		 NewBuildingInspectionOption = 'newBuildingInspectionOption',
		 NewBuildings = 'newBuildings',
		 NewBuildingsCreated = 'newBuildingsCreated',
		 NewBuildingsCreatedMailSubject = 'newBuildingsCreatedMailSubject',
		 NewChecklist = 'newChecklist',
		 NewContact = 'newContact',
		 NewCustomCheckpoint = 'newCustomCheckpoint',
		 NewEntries = 'newEntries',
		 NewestFirst = 'newestFirst',
		 NewExecutorEmail = 'newExecutorEmail',
		 NewExecutorName = 'newExecutorName',
		 NewFloor = 'newFloor',
		 NewIssue = 'newIssue',
		 NewIssueNotification = 'newIssueNotification',
		 NewIssueNotifications = 'newIssueNotifications',
		 NewIssues = 'newIssues',
		 NewMeterInspectionOption = 'newMeterInspectionOption',
		 NewMeterReadingDescription = 'newMeterReadingDescription',
		 NewPassword = 'newPassword',
		 NewResidentNotification = 'newResidentNotification',
		 NewStructuresCreatedMailSubject = 'newStructuresCreatedMailSubject',
		 NewUserCreatedMailSubject = 'newUserCreatedMailSubject',
		 Next = 'next',
		 NextPayment = 'nextPayment',
		 NextSubscriptionFee = 'nextSubscriptionFee',
		 No = 'no',
		 No_Units_Areas = 'no_Units_Areas',
		 NoAccountYet = 'noAccountYet',
		 NoActionsSpecified = 'noActionsSpecified',
		 NoAnyViewBuildingsPremission = 'noAnyViewBuildingsPremission',
		 NoAttentionPointsMessage = 'noAttentionPointsMessage',
		 NoBuildingLayersPopupMessage = 'noBuildingLayersPopupMessage',
		 NoBuildingLayersPopupTitle = 'noBuildingLayersPopupTitle',
		 NoBuildingLoginMessage = 'noBuildingLoginMessage',
		 NoBuildingsInList = 'noBuildingsInList',
		 NoBuildingsPopupMessage = 'noBuildingsPopupMessage',
		 NoBuildingsPopupTitle = 'noBuildingsPopupTitle',
		 NoCheckedInspectionDescription = 'noCheckedInspectionDescription',
		 NoCheckedInspections = 'noCheckedInspections',
		 NoCheckList = 'noCheckList',
		 NoCheckListMessage = 'noCheckListMessage',
		 NoConnectionMessage = 'noConnectionMessage',
		 NoContent = 'noContent',
		 NoContentYet = 'noContentYet',
		 NoCredits = 'noCredits',
		 NoFinishedInspections = 'noFinishedInspections',
		 NoFinishedMaintenanceActions = 'noFinishedMaintenanceActions',
		 NoFloorplanTitle = 'noFloorplanTitle',
		 NoInspections = 'noInspections',
		 NoInspectionsPerformedYet = 'noInspectionsPerformedYet',
		 NoInterventionTeams = 'noInterventionTeams',
		 NoInterventionTeamsCreated = 'noInterventionTeamsCreated',
		 NoIssues = 'noIssues',
		 NoItemsFound = 'noItemsFound',
		 NoLogoText = 'noLogoText',
		 NoMaintenanceActions = 'noMaintenanceActions',
		 NoMaintenanceActionsAssignedToYourTeam = 'noMaintenanceActionsAssignedToYourTeam',
		 NoManagerPermission = 'noManagerPermission',
		 NoMeterReadingsRecorded = 'noMeterReadingsRecorded',
		 NoMeters = 'noMeters',
		 NoMoreIssuesToShow = 'noMoreIssuesToShow',
		 None = 'none',
		 NoPermissionToLoginToApp = 'noPermissionToLoginToApp',
		 NoPrivateUnits = 'noPrivateUnits',
		 NoPrivateUnitsForBuilding = 'noPrivateUnitsForBuilding',
		 NoProductsDescription = 'noProductsDescription',
		 NoPurchasesToRestore = 'noPurchasesToRestore',
		 NoPurchasesToRestoreDescription = 'noPurchasesToRestoreDescription',
		 NoRegisteredIssuesOn = 'noRegisteredIssuesOn',
		 NoReminderSetMessage = 'noReminderSetMessage',
		 NoReportsForInspection = 'noReportsForInspection',
		 NoReportsForInspectionDescription = 'noReportsForInspectionDescription',
		 NoReservedIdsAvailableMessage = 'noReservedIdsAvailableMessage',
		 NormalText = 'normalText',
		 NoStructureCheckpoints = 'noStructureCheckpoints',
		 NoStructureElements = 'noStructureElements',
		 NoSubscription = 'noSubscription',
		 NotAccepted = 'notAccepted',
		 NotActivated = 'notActivated',
		 NotConfirmed = 'notConfirmed',
		 Note = 'note',
		 NotEnoughIssueData = 'notEnoughIssueData',
		 NotFoundHeader = 'notFoundHeader',
		 NotFoundSubheader = 'notFoundSubheader',
		 NoToDoInspections = 'noToDoInspections',
		 NoTodoMaintenanceActions = 'noTodoMaintenanceActions',
		 NoTrialCreditsRemaining = 'noTrialCreditsRemaining',
		 NotUrgent = 'notUrgent',
		 NoType = 'noType',
		 Nov = 'nov',
		 November = 'november',
		 Nr = 'nr',
		 NumberOfActiveJobs = 'numberOfActiveJobs',
		 NumberOfCopies = 'numberOfCopies',
		 NumberOfCopiesQuestion = 'numberOfCopiesQuestion',
		 NumberOfNewUnits = 'numberOfNewUnits',
		 NumberOfPinsAdded = 'numberOfPinsAdded',
		 NumberOfUnits = 'numberOfUnits',
		 Observation = 'observation',
		 ObservationDate = 'observationDate',
		 Observations = 'observations',
		 OccupantIs = 'occupantIs',
		 Oct = 'oct',
		 October = 'october',
		 Of = 'of',
		 OfChappsAreApplicable = 'ofChappsAreApplicable',
		 OK = 'oK',
		 OkIWantToSubscribe = 'okIWantToSubscribe',
		 OldestFirst = 'oldestFirst',
		 On = 'on',
		 Open = 'open',
		 OpenActions = 'openActions',
		 OpenedBy = 'openedBy',
		 OpenedOn = 'openedOn',
		 OpenIssueReview = 'openIssueReview',
		 OpenIssues = 'openIssues',
		 OpenIssuesReview = 'openIssuesReview',
		 OpenIssuesWithAllJobsCompleted = 'openIssuesWithAllJobsCompleted',
		 OpenIssuesWithoutAnyJobs = 'openIssuesWithoutAnyJobs',
		 OpenIssueWithAllJobsCompleted = 'openIssueWithAllJobsCompleted',
		 OpenIssueWithoutAnyJobs = 'openIssueWithoutAnyJobs',
		 Or = 'or',
		 OrderBy = 'orderBy',
		 OrDownloadMobileApp = 'orDownloadMobileApp',
		 Origin = 'origin',
		 OrYouCanAddNewCheckpoint = 'orYouCanAddNewCheckpoint',
		 OrYouCanDuplicateAnExistingOne = 'orYouCanDuplicateAnExistingOne',
		 OrYouCanLoginInTheChappsManager = 'orYouCanLoginInTheChappsManager',
		 OrYouCanProvideAllNecessaryInformationByYourself = 'orYouCanProvideAllNecessaryInformationByYourself',
		 OSVersion = 'oSVersion',
		 Other = 'other',
		 OtherIssues = 'otherIssues',
		 Page = 'page',
		 PaperFormat = 'paperFormat',
		 PartnerManagement = 'partnerManagement',
		 PartnersSettings = 'partnersSettings',
		 Password = 'password',
		 PasswordLengthError = 'passwordLengthError',
		 PasswordlessMagicLinkMailSubject = 'passwordlessMagicLinkMailSubject',
		 PasswordMismatchError = 'passwordMismatchError',
		 PasswordMustBeAtLeast = 'passwordMustBeAtLeast',
		 PasswordReset = 'passwordReset',
		 PasswordsDoNotMatch = 'passwordsDoNotMatch',
		 Pay = 'pay',
		 Payment = 'payment',
		 PaymentGeneralTerms = 'paymentGeneralTerms',
		 PaymentInformation = 'paymentInformation',
		 PaymentPrivacyPolicy = 'paymentPrivacyPolicy',
		 Payments = 'payments',
		 PaymentSoftwareLicense = 'paymentSoftwareLicense',
		 PaymentStep1Description = 'paymentStep1Description',
		 PaymentStep1Header = 'paymentStep1Header',
		 PaymentStep1HeaderDescription = 'paymentStep1HeaderDescription',
		 PaymentStep1HeaderDescriptionReportCredit = 'paymentStep1HeaderDescriptionReportCredit',
		 PaymentStep2Header = 'paymentStep2Header',
		 PaymentStep2HeaderDescription = 'paymentStep2HeaderDescription',
		 PaymentStep3Header = 'paymentStep3Header',
		 PaymentStep3HeaderDescription = 'paymentStep3HeaderDescription',
		 PaymentTerms = 'paymentTerms',
		 PendingJobsPreventIssueResolutionNotice = 'pendingJobsPreventIssueResolutionNotice',
		 PeriodShownForFinishedJobs = 'periodShownForFinishedJobs',
		 PermissionExplanation_BuildingChecklistsView = 'permissionExplanation_BuildingChecklistsView',
		 PermissionExplanation_BuildingDashboardView = 'permissionExplanation_BuildingDashboardView',
		 PermissionExplanation_BuildingHistoryView = 'permissionExplanation_BuildingHistoryView',
		 PermissionExplanation_BuildingIssuesView = 'permissionExplanation_BuildingIssuesView',
		 PermissionExplanation_BuildingMetersView = 'permissionExplanation_BuildingMetersView',
		 PermissionExplanation_BuildingsAdd = 'permissionExplanation_BuildingsAdd',
		 PermissionExplanation_BuildingsEdit = 'permissionExplanation_BuildingsEdit',
		 PermissionExplanation_BuildingStructureView = 'permissionExplanation_BuildingStructureView',
		 PermissionExplanation_BuildingsView = 'permissionExplanation_BuildingsView',
		 PermissionExplanation_CompanyInfoLogoUploadView = 'permissionExplanation_CompanyInfoLogoUploadView',
		 PermissionExplanation_ContactsEdit = 'permissionExplanation_ContactsEdit',
		 PermissionExplanation_ContactsView = 'permissionExplanation_ContactsView',
		 PermissionExplanation_DevicesView = 'permissionExplanation_DevicesView',
		 PermissionExplanation_DocumentsEdit = 'permissionExplanation_DocumentsEdit',
		 PermissionExplanation_DocumentsView = 'permissionExplanation_DocumentsView',
		 PermissionExplanation_EditJobs = 'permissionExplanation_EditJobs',
		 PermissionExplanation_EditOnTheGo = 'permissionExplanation_EditOnTheGo',
		 PermissionExplanation_Inspect = 'permissionExplanation_Inspect',
		 PermissionExplanation_InspectionAssignExecutor = 'permissionExplanation_InspectionAssignExecutor',
		 PermissionExplanation_InspectionsEdit = 'permissionExplanation_InspectionsEdit',
		 PermissionExplanation_InspectionsExecuteChecklist = 'permissionExplanation_InspectionsExecuteChecklist',
		 PermissionExplanation_InspectionsExecuteCheckUp = 'permissionExplanation_InspectionsExecuteCheckUp',
		 PermissionExplanation_InspectionsExecuteInspect = 'permissionExplanation_InspectionsExecuteInspect',
		 PermissionExplanation_InspectionsExecuteIntake = 'permissionExplanation_InspectionsExecuteIntake',
		 PermissionExplanation_InspectionsExecuteJanitor = 'permissionExplanation_InspectionsExecuteJanitor',
		 PermissionExplanation_InspectionsExecuteMeterReading = 'permissionExplanation_InspectionsExecuteMeterReading',
		 PermissionExplanation_InspectionsExecuteQuickAudit = 'permissionExplanation_InspectionsExecuteQuickAudit',
		 PermissionExplanation_InspectionsExecuteQuickAuditLite = 'permissionExplanation_InspectionsExecuteQuickAuditLite',
		 PermissionExplanation_InspectionsExecuteSystems = 'permissionExplanation_InspectionsExecuteSystems',
		 PermissionExplanation_InspectionsView = 'permissionExplanation_InspectionsView',
		 PermissionExplanation_Inspector = 'permissionExplanation_Inspector',
		 PermissionExplanation_IssueResolve = 'permissionExplanation_IssueResolve',
		 PermissionExplanation_IssuesAssignContractor = 'permissionExplanation_IssuesAssignContractor',
		 PermissionExplanation_MaintenanceExecute = 'permissionExplanation_MaintenanceExecute',
		 PermissionExplanation_MaintenanceView = 'permissionExplanation_MaintenanceView',
		 PermissionExplanation_Manager = 'permissionExplanation_Manager',
		 PermissionExplanation_ManagerBuildingChecklistsView = 'permissionExplanation_ManagerBuildingChecklistsView',
		 PermissionExplanation_ManagerBuildingIssuesView = 'permissionExplanation_ManagerBuildingIssuesView',
		 PermissionExplanation_ManagerBuildingMetersView = 'permissionExplanation_ManagerBuildingMetersView',
		 PermissionExplanation_ManagerBuildingStructureView = 'permissionExplanation_ManagerBuildingStructureView',
		 PermissionExplanation_PartnerManagement = 'permissionExplanation_PartnerManagement',
		 PermissionExplanation_Payment = 'permissionExplanation_Payment',
		 PermissionExplanation_ReportSettingsView = 'permissionExplanation_ReportSettingsView',
		 PermissionExplanation_RolesEdit = 'permissionExplanation_RolesEdit',
		 PermissionExplanation_UserManagement = 'permissionExplanation_UserManagement',
		 Phone = 'phone',
		 PhoneNumber = 'phoneNumber',
		 PhoneNumberIsIncorrect = 'phoneNumberIsIncorrect',
		 Photo = 'photo',
		 Photos = 'photos',
		 PhysicalLocation = 'physicalLocation',
		 Picture = 'picture',
		 Pictures = 'pictures',
		 PinpointLocation = 'pinpointLocation',
		 Planned = 'planned',
		 PlannedInspections = 'plannedInspections',
		 Platform = 'platform',
		 PleaseCheckYourEmail = 'pleaseCheckYourEmail',
		 PleaseContactWithAdministrator = 'pleaseContactWithAdministrator',
		 PleaseEnterAValidEmailAddress = 'pleaseEnterAValidEmailAddress',
		 PleaseGoBackToAppToContinue = 'pleaseGoBackToAppToContinue',
		 PleaseSyncFirst = 'pleaseSyncFirst',
		 PositiveValueLabel = 'positiveValueLabel',
		 Predefined = 'predefined',
		 PredefinedChecklistAlert = 'predefinedChecklistAlert',
		 PredefinedCheckpoints = 'predefinedCheckpoints',
		 PremiumOnly = 'premiumOnly',
		 Preview = 'preview',
		 PreviewReport = 'previewReport',
		 Previous = 'previous',
		 PreviouslyAddedCheckpoints = 'previouslyAddedCheckpoints',
		 PreviousMeterReading = 'previousMeterReading',
		 PreviousValue = 'previousValue',
		 PrivacyPolicyUrl = 'privacyPolicyUrl',
		 PrivateMeters = 'privateMeters',
		 PrivateUnit = 'privateUnit',
		 PrivateUnitFloor = 'privateUnitFloor',
		 PrivateUnitLabel = 'privateUnitLabel',
		 PrivateUnits = 'privateUnits',
		 PrivateUnitsAndCommonAreas = 'privateUnitsAndCommonAreas',
		 Proceed = 'proceed',
		 ProceedToStep2BillingInformation = 'proceedToStep2BillingInformation',
		 ProceedToStep3Confirmation = 'proceedToStep3Confirmation',
		 Processing = 'processing',
		 Product = 'product',
		 ProductChoice = 'productChoice',
		 ProductInfo = 'productInfo',
		 Products = 'products',
		 ProOnly = 'proOnly',
		 ProPremiumOnly = 'proPremiumOnly',
		 ProvideInformationAboutUserFunctionInAllBuildingsOrInTheSingleBuilding = 'provideInformationAboutUserFunctionInAllBuildingsOrInTheSingleBuilding',
		 ProvidePasswordForLogin = 'providePasswordForLogin',
		 Provider = 'provider',
		 Province = 'province',
		 PurchaseCredits = 'purchaseCredits',
		 PurchaseInfoBody = 'purchaseInfoBody',
		 Quantity = 'quantity',
		 QuickAudit = 'quickAudit',
		 QuickAuditDescription = 'quickAuditDescription',
		 QuickAuditDisabledDescription = 'quickAuditDisabledDescription',
		 Received = 'received',
		 Record = 'record',
		 RecordedMeters = 'recordedMeters',
		 RecordVideoHeader = 'recordVideoHeader',
		 RecoveryMessage = 'recoveryMessage',
		 RecoveryTitle = 'recoveryTitle',
		 RecurrencyType_Monthly = 'recurrencyType_Monthly',
		 RecurrencyType_Total = 'recurrencyType_Total',
		 RecurrencyType_Yearly = 'recurrencyType_Yearly',
		 RecurringPaymentFailedMailSubject = 'recurringPaymentFailedMailSubject',
		 Ref = 'ref',
		 Reference = 'reference',
		 Refresh = 'refresh',
		 RefTokenExpired = 'refTokenExpired',
		 Register = 'register',
		 RegisteredOn = 'registeredOn',
		 RegistrationComplete = 'registrationComplete',
		 RegistrationNumber = 'registrationNumber',
		 RegistrationNumberFieldIsRequired = 'registrationNumberFieldIsRequired',
		 RegistrationNumberIs = 'registrationNumberIs',
		 RegistrationNumberIsInvalid = 'registrationNumberIsInvalid',
		 Reminder = 'reminder',
		 ReminderCreatedNotification = 'reminderCreatedNotification',
		 ReminderDeletedNotification = 'reminderDeletedNotification',
		 Reminders = 'reminders',
		 ReminderSetForMessage = 'reminderSetForMessage',
		 Removal = 'removal',
		 Remove = 'remove',
		 RemoveAccountMailSubject = 'removeAccountMailSubject',
		 RemoveAction = 'removeAction',
		 RemoveFloorPlanCTA = 'removeFloorPlanCTA',
		 RemoveFromFavourites = 'removeFromFavourites',
		 RenameChecklist = 'renameChecklist',
		 RenewsOnDate = 'renewsOnDate',
		 RenewYourSubscription = 'renewYourSubscription',
		 RenewYourSubscriptionNow = 'renewYourSubscriptionNow',
		 Report = 'report',
		 ReportAvailable = 'reportAvailable',
		 ReportedBy = 'reportedBy',
		 Reports = 'reports',
		 ReportSettings = 'reportSettings',
		 ReportSettingsView = 'reportSettingsView',
		 ReportsForInspectionSoonAvailable = 'reportsForInspectionSoonAvailable',
		 ReportType = 'reportType',
		 Requested = 'requested',
		 RequestErrorMessage = 'requestErrorMessage',
		 Required = 'required',
		 RequiredFieldsAreMissing = 'requiredFieldsAreMissing',
		 RequiresAttention = 'requiresAttention',
		 ResendInvitationMail = 'resendInvitationMail',
		 Reset = 'reset',
		 ResetPassword = 'resetPassword',
		 ResetPasswordSuccess = 'resetPasswordSuccess',
		 Residence = 'residence',
		 ResidenceOrStreetFieldIsRequired = 'residenceOrStreetFieldIsRequired',
		 Residency = 'residency',
		 ResidentNotificationAddedMessage = 'residentNotificationAddedMessage',
		 Resolve = 'resolve',
		 Resolved = 'resolved',
		 ResolvedBy = 'resolvedBy',
		 ResolvedOn = 'resolvedOn',
		 ResolveIssue = 'resolveIssue',
		 ResolveIssueDescription = 'resolveIssueDescription',
		 ResolveIssueMessage = 'resolveIssueMessage',
		 ResolveIssueModal = 'resolveIssueModal',
		 ResolveIssuesModal = 'resolveIssuesModal',
		 RestoreDefault = 'restoreDefault',
		 RestorePurchases = 'restorePurchases',
		 RestorePurchasesDescription = 'restorePurchasesDescription',
		 RestorePurchasesSuccessfulDescription = 'restorePurchasesSuccessfulDescription',
		 ReturnedResult = 'returnedResult',
		 ReturnToChappsChappsManager = 'returnToChappsChappsManager',
		 ReuseChargeDirectiveInformation = 'reuseChargeDirectiveInformation',
		 ReviewIssue = 'reviewIssue',
		 ReviewIssues = 'reviewIssues',
		 Risk = 'risk',
		 Role = 'role',
		 RoleOptional = 'roleOptional',
		 Roles = 'roles',
		 RolesEdit = 'rolesEdit',
		 RoomsNumber = 'roomsNumber',
		 Routines = 'routines',
		 SafetyIssue = 'safetyIssue',
		 SalesTax = 'salesTax',
		 Sat = 'sat',
		 Saturday = 'saturday',
		 Save = 'save',
		 SaveAndCreateJob = 'saveAndCreateJob',
		 SaveAndSend = 'saveAndSend',
		 SaveIssueOnly = 'saveIssueOnly',
		 ScheduldOn = 'scheduldOn',
		 Scheduled = 'scheduled',
		 ScheduledFor = 'scheduledFor',
		 ScheduledOn = 'scheduledOn',
		 Search = 'search',
		 Section = 'section',
		 SectionLabel = 'sectionLabel',
		 Security = 'security',
		 SecurityBlock = 'securityBlock',
		 SecurityIssue = 'securityIssue',
		 SeeAll = 'seeAll',
		 SeeCheckPointTemplateComment = 'seeCheckPointTemplateComment',
		 SeeDetails = 'seeDetails',
		 Select = 'select',
		 SelectAChecklist = 'selectAChecklist',
		 SelectAll = 'selectAll',
		 SelectAnotherFile = 'selectAnotherFile',
		 SelectBuilding = 'selectBuilding',
		 SelectBuildingTypeAlert = 'selectBuildingTypeAlert',
		 SelectCategoryToSeeTypes = 'selectCategoryToSeeTypes',
		 SelectContact = 'selectContact',
		 SelectedBuildings = 'selectedBuildings',
		 SelectedImage = 'selectedImage',
		 SelectFile = 'selectFile',
		 SelectFloorPlanCTA = 'selectFloorPlanCTA',
		 SelectMeterType = 'selectMeterType',
		 SelectNumberOfBuildings = 'selectNumberOfBuildings',
		 SelectNumberOfUnits = 'selectNumberOfUnits',
		 SelectNumberOfUsers = 'selectNumberOfUsers',
		 SelectState = 'selectState',
		 SelectTypeToSeeObservations = 'selectTypeToSeeObservations',
		 Send = 'send',
		 SendAgain = 'sendAgain',
		 Sending = 'sending',
		 SendNewActivationCodeDescription = 'sendNewActivationCodeDescription',
		 SendNewActivationCodeTitle = 'sendNewActivationCodeTitle',
		 Sep = 'sep',
		 September = 'september',
		 ServiceOverview = 'serviceOverview',
		 SetNewAccountBuildingRole = 'setNewAccountBuildingRole',
		 SetNewAccountDetailInformation = 'setNewAccountDetailInformation',
		 SetNewRoleName = 'setNewRoleName',
		 SetReminder = 'setReminder',
		 Settings = 'settings',
		 SetupBuilding = 'setupBuilding',
		 SetWithoutConsequences = 'setWithoutConsequences',
		 SharedUnits = 'sharedUnits',
		 SheduledOn = 'sheduledOn',
		 ShowPremium = 'showPremium',
		 ShowProPremium = 'showProPremium',
		 Signature = 'signature',
		 SignatureCompanyDescription = 'signatureCompanyDescription',
		 SignatureNameDescription = 'signatureNameDescription',
		 SignatureRoleDescription = 'signatureRoleDescription',
		 SignIn = 'signIn',
		 SignInLinkExpired = 'signInLinkExpired',
		 SingleMediaAddedNotification = 'singleMediaAddedNotification',
		 SingleMediaDeletedNotification = 'singleMediaDeletedNotification',
		 Site = 'site',
		 SiteCharacteristics = 'siteCharacteristics',
		 SiteName = 'siteName',
		 SiteSetup = 'siteSetup',
		 SkipToActivation = 'skipToActivation',
		 SkipToActivationStep = 'skipToActivationStep',
		 SmartFastAccurate = 'smartFastAccurate',
		 Snooze = 'snooze',
		 Snoozed = 'snoozed',
		 SnoozedBy = 'snoozedBy',
		 SnoozedOn = 'snoozedOn',
		 SnoozedUntil = 'snoozedUntil',
		 SnoozeIssue = 'snoozeIssue',
		 SomethingWentWrongWhileTryingToCreateNewAccount = 'somethingWentWrongWhileTryingToCreateNewAccount',
		 SomethingWentWrongWhileTryingToCreateNewBuilding = 'somethingWentWrongWhileTryingToCreateNewBuilding',
		 SomethingWentWrongWhileTryingToVerifyEmailPleaseTryAgain = 'somethingWentWrongWhileTryingToVerifyEmailPleaseTryAgain',
		 SortBy = 'sortBy',
		 Source = 'source',
		 Space = 'space',
		 Spaces = 'spaces',
		 StartBuildingInspectionAlert = 'startBuildingInspectionAlert',
		 StartedOn = 'startedOn',
		 StartIntakeInspection = 'startIntakeInspection',
		 StartMySubscription = 'startMySubscription',
		 StartPlannedBuildingInspectionDescription = 'startPlannedBuildingInspectionDescription',
		 StartPlannedBuildingInspectionOption = 'startPlannedBuildingInspectionOption',
		 StartPlannedMeterReadingDescription = 'startPlannedMeterReadingDescription',
		 StartPlannedMeterReadingOption = 'startPlannedMeterReadingOption',
		 StartTheInspection = 'startTheInspection',
		 State = 'state',
		 StateOfTheBuilding = 'stateOfTheBuilding',
		 Status = 'status',
		 StatusTitleAccepted = 'statusTitleAccepted',
		 statusTitleDeclined = 'statusTitleDeclined',
		 StatusTitleExecuting = 'statusTitleExecuting',
		 StatusTitleFinished = 'statusTitleFinished',
		 StepOf = 'stepOf',
		 StopRecording = 'stopRecording',
		 Street = 'street',
		 StreetNameIs = 'streetNameIs',
		 Structural = 'structural',
		 StructuralBlock = 'structuralBlock',
		 StructuralIssue = 'structuralIssue',
		 Structure = 'structure',
		 StructureDescriptionBuilding = 'structureDescriptionBuilding',
		 StructureDescriptionSite = 'structureDescriptionSite',
		 Structures = 'structures',
		 SubLivingUnit = 'subLivingUnit',
		 SubLivingUnits = 'subLivingUnits',
		 Submit = 'submit',
		 Subscribe = 'subscribe',
		 SubscribeNow = 'subscribeNow',
		 SubscribeNowAfterTrial = 'subscribeNowAfterTrial',
		 SubscribeNowDuringTrial = 'subscribeNowDuringTrial',
		 SubscribeNowEmailSubject = 'subscribeNowEmailSubject',
		 SubscribeToPurchase = 'subscribeToPurchase',
		 Subscription = 'subscription',
		 SubscriptionCreditsTrial = 'subscriptionCreditsTrial',
		 SubscriptionDescription = 'subscriptionDescription',
		 SubscriptionExpiredOn = 'subscriptionExpiredOn',
		 SubscriptionGo = 'subscriptionGo',
		 SubscriptionHasExpiredEmailSubject = 'subscriptionHasExpiredEmailSubject',
		 SubscriptionInfoBody = 'subscriptionInfoBody',
		 SubscriptionIsValidUntil = 'subscriptionIsValidUntil',
		 SubscriptionLapsed = 'subscriptionLapsed',
		 SubscriptionLite = 'subscriptionLite',
		 SubscriptionPro = 'subscriptionPro',
		 SubscriptionRenewalInfoBody = 'subscriptionRenewalInfoBody',
		 SubscriptionRequired = 'subscriptionRequired',
		 SubscriptionRequiredDescription = 'subscriptionRequiredDescription',
		 SubscriptionType = 'subscriptionType',
		 SubStructures = 'subStructures',
		 Subtotal = 'subtotal',
		 Subtype = 'subtype',
		 SubUnit = 'subUnit',
		 Subunits = 'subunits',
		 SuccesfullyCreatedBuilding = 'succesfullyCreatedBuilding',
		 SuccesfullyCreatedSite = 'succesfullyCreatedSite',
		 Success = 'success',
		 SuccessfulPaymentHeader = 'successfulPaymentHeader',
		 SuccessfulPaymentMessage = 'successfulPaymentMessage',
		 SuccessTrial = 'successTrial',
		 Summary = 'summary',
		 Sun = 'sun',
		 Sunday = 'sunday',
		 SupportedFileExtension = 'supportedFileExtension',
		 SupportTitle = 'supportTitle',
		 Surface = 'surface',
		 SurfaceArea = 'surfaceArea',
		 Sync = 'sync',
		 SyncCompleted = 'syncCompleted',
		 SyncFailed = 'syncFailed',
		 Syncing = 'syncing',
		 SyncingProgress = 'syncingProgress',
		 SyncStarted = 'syncStarted',
		 SystemsDescription = 'systemsDescription',
		 SystemsDisabledDescription = 'systemsDisabledDescription',
		 SystemsReport = 'systemsReport',
		 TableOfContents = 'tableOfContents',
		 TakeAPhoto = 'takeAPhoto',
		 Team = 'team',
		 TeamName = 'teamName',
		 TeamOverview = 'teamOverview',
		 Technical = 'technical',
		 TechnicalBlock = 'technicalBlock',
		 Temperature = 'temperature',
		 TextColor = 'textColor',
		 ThanksYourPaymentWasSuccessful = 'thanksYourPaymentWasSuccessful',
		 TheCardWillExpireSoonMailSubject = 'theCardWillExpireSoonMailSubject',
		 TheGeneralConditions = 'theGeneralConditions',
		 TheListBelowContainsAllNegativelyEvaluatedCheckpointsOfTheLatestCheckupInspection = 'theListBelowContainsAllNegativelyEvaluatedCheckpointsOfTheLatestCheckupInspection',
		 ThePurchasedProductsCanBeUsed = 'thePurchasedProductsCanBeUsed',
		 ThereAreNoAccountDetailsInTheApp = 'thereAreNoAccountDetailsInTheApp',
		 ThereAreNoAccountsCreatedInTheApp = 'thereAreNoAccountsCreatedInTheApp',
		 ThereAreNoDeviceDetailsInTheApp = 'thereAreNoDeviceDetailsInTheApp',
		 ThereAreNoDevicesStoredInTheApp = 'thereAreNoDevicesStoredInTheApp',
		 ThereAreNoEntriesThatMatchSelectedCriteria = 'thereAreNoEntriesThatMatchSelectedCriteria',
		 ThereAreNoNegativelyEvaluatedCheckpointsOfTheLatestCheckupInspection = 'thereAreNoNegativelyEvaluatedCheckpointsOfTheLatestCheckupInspection',
		 ThereAreNoRolesOrPermissionsInTheApp = 'thereAreNoRolesOrPermissionsInTheApp',
		 ThereAreNoTeamsCreatedYet = 'thereAreNoTeamsCreatedYet',
		 ThereIsNoBusinessInformationInTheApp = 'thereIsNoBusinessInformationInTheApp',
		 ThereWasAlreadyAnAccountCreatedForThisEmailAddress = 'thereWasAlreadyAnAccountCreatedForThisEmailAddress',
		 TheseProductsWillBeAvailableUntilSubscriptionExpirationDate = 'theseProductsWillBeAvailableUntilSubscriptionExpirationDate',
		 ThisBuildingContactDoesNotBelongToAnyInterventionTeam = 'thisBuildingContactDoesNotBelongToAnyInterventionTeam',
		 ThisBuildingContactDoesNotHaveAnyDocumentsYet = 'thisBuildingContactDoesNotHaveAnyDocumentsYet',
		 ThisBuildingContactDoesNotHaveAnyFunctionsYet = 'thisBuildingContactDoesNotHaveAnyFunctionsYet',
		 ThisBuildingDoesNotHaveAddressInformationAttached = 'thisBuildingDoesNotHaveAddressInformationAttached',
		 ThisBuildingDoesNotHaveAnyActions = 'thisBuildingDoesNotHaveAnyActions',
		 ThisBuildingDoesNotHaveAnyContactsYet = 'thisBuildingDoesNotHaveAnyContactsYet',
		 ThisBuildingDoesNotHaveAnyDocuments = 'thisBuildingDoesNotHaveAnyDocuments',
		 ThisBuildingDoesNotHaveAnyInspectionsYet = 'thisBuildingDoesNotHaveAnyInspectionsYet',
		 ThisBuildingDoesNotHaveAnyIssues = 'thisBuildingDoesNotHaveAnyIssues',
		 ThisBuildingDoesNotHaveAnyPhotos = 'thisBuildingDoesNotHaveAnyPhotos',
		 ThisCheckpointDoesNotHaveAnyIssues = 'thisCheckpointDoesNotHaveAnyIssues',
		 ThisCheckpointDoesNotHaveAnyMedia = 'thisCheckpointDoesNotHaveAnyMedia',
		 ThisEmailContainsALinkWhichLetYouContinueWithRegistartationProccess = 'thisEmailContainsALinkWhichLetYouContinueWithRegistartationProccess',
		 ThisEmailIncludesALinkWhichLetsUser = 'thisEmailIncludesALinkWhichLetsUser',
		 ThisEmailIncludesALinkWhichLetsYou = 'thisEmailIncludesALinkWhichLetsYou',
		 ThisInspectionDoesNotHaveAnyCheckpoints = 'thisInspectionDoesNotHaveAnyCheckpoints',
		 ThisInspectionDoesNotHaveAnyDocumentsYet = 'thisInspectionDoesNotHaveAnyDocumentsYet',
		 ThisInspectionDoesNotHaveDetailsInformationAttached = 'thisInspectionDoesNotHaveDetailsInformationAttached',
		 ThisInspectionDoesNotHaveMetricsInformationAttached = 'thisInspectionDoesNotHaveMetricsInformationAttached',
		 ThisInterventionTeamDoesNotHaveAnyContacts = 'thisInterventionTeamDoesNotHaveAnyContacts',
		 ThisInterventionTeamDoesNotHaveAnyDetailsInformation = 'thisInterventionTeamDoesNotHaveAnyDetailsInformation',
		 ThisIssueDoesNotHaveAnyActions = 'thisIssueDoesNotHaveAnyActions',
		 ThisIssueDoesNotHaveAnyInterventionTeams = 'thisIssueDoesNotHaveAnyInterventionTeams',
		 ThisIssueDoesNotHaveAnyLogEntries = 'thisIssueDoesNotHaveAnyLogEntries',
		 ThisIssueDoesNotHaveAnyMedia = 'thisIssueDoesNotHaveAnyMedia',
		 ThisUnitDoesNotHaveAnyContactsAddedYet = 'thisUnitDoesNotHaveAnyContactsAddedYet',
		 ThisUnitDoesNotHaveAnyMetersAddedYet = 'thisUnitDoesNotHaveAnyMetersAddedYet',
		 ThisUserHasNoRolesAssigned = 'thisUserHasNoRolesAssigned',
		 Thu = 'thu',
		 Thursday = 'thursday',
		 TimeOfDay = 'timeOfDay',
		 Title = 'title',
		 To = 'to',
		 ToCantBeBeforeFrom = 'toCantBeBeforeFrom',
		 ToClean = 'toClean',
		 ToDateCannotBeEarlierFromDate = 'toDateCannotBeEarlierFromDate',
		 Today = 'today',
		 ToDo = 'toDo',
		 ToFix = 'toFix',
		 ToInspect = 'toInspect',
		 ToMaintain = 'toMaintain',
		 ToPaint = 'toPaint',
		 ToRebuild = 'toRebuild',
		 ToRemove = 'toRemove',
		 ToRepair = 'toRepair',
		 ToReplace = 'toReplace',
		 ToSync = 'toSync',
		 Total = 'total',
		 TotalExclSalesTax = 'totalExclSalesTax',
		 TotalInclSalesTax = 'totalInclSalesTax',
		 TotalIssues = 'totalIssues',
		 TotalVatExcl = 'totalVatExcl',
		 TotalVatIncl = 'totalVatIncl',
		 TourBuildingsAddText = 'tourBuildingsAddText',
		 TourBuildingsAddTitle = 'tourBuildingsAddTitle',
		 TourBuildingsAppDownloadText = 'tourBuildingsAppDownloadText',
		 TourBuildingsAppDownloadTitle = 'tourBuildingsAppDownloadTitle',
		 TourBuildingsDemoContentText = 'tourBuildingsDemoContentText',
		 TourBuildingsDemoContentTitle = 'tourBuildingsDemoContentTitle',
		 TourBuildingsExploreText = 'tourBuildingsExploreText',
		 TourBuildingsExploreTitle = 'tourBuildingsExploreTitle',
		 TourCTABack = 'tourCTABack',
		 TourCTAFinish = 'tourCTAFinish',
		 TourCTANext = 'tourCTANext',
		 TourCTASkip = 'tourCTASkip',
		 TourInspectionsAddText = 'tourInspectionsAddText',
		 TourInspectionsAddTitle = 'tourInspectionsAddTitle',
		 TourInspectionsFilterText = 'tourInspectionsFilterText',
		 TourInspectionsFilterTitle = 'tourInspectionsFilterTitle',
		 TourInspectionsScreenText = 'tourInspectionsScreenText',
		 TourInspectionsScreenTitle = 'tourInspectionsScreenTitle',
		 TourIssuesAddText = 'tourIssuesAddText',
		 TourIssuesAddTitle = 'tourIssuesAddTitle',
		 TourIssuesScreenText = 'tourIssuesScreenText',
		 TourIssuesScreenTitle = 'tourIssuesScreenTitle',
		 TourStepIndicator = 'tourStepIndicator',
		 TransactionHistory = 'transactionHistory',
		 TrialCreditsRemaining = 'trialCreditsRemaining',
		 TrialEnded = 'trialEnded',
		 Tue = 'tue',
		 Tuesday = 'tuesday',
		 Type = 'type',
		 TypeOfJob = 'typeOfJob',
		 TypeOfProblem = 'typeOfProblem',
		 Unassign = 'unassign',
		 Unassigned = 'unassigned',
		 UnassignJob = 'unassignJob',
		 UnchangedEntries = 'unchangedEntries',
		 Understood = 'understood',
		 UnitArea = 'unitArea',
		 UnitList = 'unitList',
		 UnitPrice = 'unitPrice',
		 Units = 'units',
		 Unknown = 'unknown',
		 UnknownErrorOccurredMessage = 'unknownErrorOccurredMessage',
		 UnreadIssueNotificationMessage = 'unreadIssueNotificationMessage',
		 UnreadIssueNotificationMessages = 'unreadIssueNotificationMessages',
		 UnrecordedMeters = 'unrecordedMeters',
		 UnsetWithoutConsequences = 'unsetWithoutConsequences',
		 UnsupportedDocumentsExtensionsMessage = 'unsupportedDocumentsExtensionsMessage',
		 UnsupportedFileType = 'unsupportedFileType',
		 UnsupportedImportContactsExtensionsMessage = 'unsupportedImportContactsExtensionsMessage',
		 Until = 'until',
		 Update = 'update',
		 UpdateAlertMessageAndroid = 'updateAlertMessageAndroid',
		 UpdateAlertMessageiOs = 'updateAlertMessageiOs',
		 UpdateAlertTitle = 'updateAlertTitle',
		 UpdateApp = 'updateApp',
		 UpdatedBuildings = 'updatedBuildings',
		 UpdatedEntries = 'updatedEntries',
		 UpdatedSubscriptionMailSubject = 'updatedSubscriptionMailSubject',
		 UpdateNotificationMessageiOs = 'updateNotificationMessageiOs',
		 UpdateNotificationTitle = 'updateNotificationTitle',
		 UpdateRoleName = 'updateRoleName',
		 Updates = 'updates',
		 Upgrade = 'upgrade',
		 UpgradeDB = 'upgradeDB',
		 UpgradeDBMessage = 'upgradeDBMessage',
		 UpgradeDescription = 'upgradeDescription',
		 UpgradeToPremium = 'upgradeToPremium',
		 UpgradeToPro = 'upgradeToPro',
		 UpgradeToProPremium = 'upgradeToProPremium',
		 UploadDB = 'uploadDB',
		 Uploaded = 'uploaded',
		 UploadedDB = 'uploadedDB',
		 UploadFile = 'uploadFile',
		 Uploading = 'uploading',
		 Ups = 'ups',
		 UpsItLooksLikeThisSectionHasNoInformationAvailable = 'upsItLooksLikeThisSectionHasNoInformationAvailable',
		 Urgency = 'urgency',
		 Urgent = 'urgent',
		 UrgentIssues = 'urgentIssues',
		 UrgentOnly = 'urgentOnly',
		 UseCamera = 'useCamera',
		 User = 'user',
		 UserManagement = 'userManagement',
		 Username = 'username',
		 UsernameAlreadyExists = 'usernameAlreadyExists',
		 UsernameIsValid = 'usernameIsValid',
		 Users = 'users',
		 Utilities = 'utilities',
		 ValidEntries = 'validEntries',
		 Value = 'value',
		 Vat = 'vat',
		 VatNumber = 'vatNumber',
		 VatRegulations = 'vatRegulations',
		 VersionBuild = 'versionBuild',
		 VideoClipPreviewHeader = 'videoClipPreviewHeader',
		 VideoProcessingInfo = 'videoProcessingInfo',
		 ViewInspectionDetails = 'viewInspectionDetails',
		 ViewIssueAndJob = 'viewIssueAndJob',
		 ViewLogbook = 'viewLogbook',
		 Visible = 'visible',
		 VisitBuilding = 'visitBuilding',
		 Water = 'water',
		 Weather = 'weather',
		 Wed = 'wed',
		 Wednesday = 'wednesday',
		 Week = 'week',
		 Weeks = 'weeks',
		 Welcome = 'welcome',
		 WelcomeMailSubject = 'welcomeMailSubject',
		 WelcomeModalContent = 'welcomeModalContent',
		 WhereDidTheIssueOccur = 'whereDidTheIssueOccur',
		 WhiteText = 'whiteText',
		 WithAllJobsCompleted = 'withAllJobsCompleted',
		 WithConsequences = 'withConsequences',
		 WithExpiredDateOnly = 'withExpiredDateOnly',
		 WithIssues = 'withIssues',
		 WithoutAnyJobs = 'withoutAnyJobs',
		 WithoutConsequences = 'withoutConsequences',
		 WithoutIssues = 'withoutIssues',
		 WithUrgentJobs = 'withUrgentJobs',
		 WorkOrderReference = 'workOrderReference',
		 WrongRegistrationNumberFormat = 'wrongRegistrationNumberFormat',
		 Year = 'year',
		 Yearly = 'yearly',
		 Years = 'years',
		 Yes = 'yes',
		 YouAreMemberOfSubsciption = 'youAreMemberOfSubsciption',
		 YouCanCreateNewEmptyChecklist = 'youCanCreateNewEmptyChecklist',
		 YouCanCreateNewNode = 'youCanCreateNewNode',
		 YouCanCreateNewUserAccountUsingExistingContactData = 'youCanCreateNewUserAccountUsingExistingContactData',
		 YouCanDownloadEmptyTemplateFileFrom = 'youCanDownloadEmptyTemplateFileFrom',
		 YouCannotDeleteRoleThatIsBeingUsedByAtLeastOneUse = 'youCannotDeleteRoleThatIsBeingUsedByAtLeastOneUse',
		 YouCannotSetLessBuildingAndUsersThanYouAlreadyHave = 'youCannotSetLessBuildingAndUsersThanYouAlreadyHave',
		 YouCanNowLogin = 'youCanNowLogin',
		 YouCantDeactivateYourself = 'youCantDeactivateYourself',
		 YouDontHaveAnyBuildingsAssignedToYourAccount = 'youDontHaveAnyBuildingsAssignedToYourAccount',
		 YouDontHaveAnyFloorCreatedYetPleaseCreateOne = 'youDontHaveAnyFloorCreatedYetPleaseCreateOne',
		 YouHaveADemoSubscription = 'youHaveADemoSubscription',
		 YouHaveNoNewInformation = 'youHaveNoNewInformation',
		 YouHaveSuccessfullySavedReportSettingsLayout = 'youHaveSuccessfullySavedReportSettingsLayout',
		 YouHaveUnhandledAttentionPoint = 'youHaveUnhandledAttentionPoint',
		 YouHaveUnhandledAttentionPoints = 'youHaveUnhandledAttentionPoints',
		 YouHaveUnhandledChecklistAttentionPoint = 'youHaveUnhandledChecklistAttentionPoint',
		 YouHaveUnhandledChecklistAttentionPoints = 'youHaveUnhandledChecklistAttentionPoints',
		 YouNeedToFillMandatoryCheckpointsFirst = 'youNeedToFillMandatoryCheckpointsFirst',
		 YourAccountHasBeenSuccessfullyCreated = 'yourAccountHasBeenSuccessfullyCreated',
		 YourBoughtProducts = 'yourBoughtProducts',
		 YourEmail = 'yourEmail',
		 YourPassword = 'yourPassword',
		 YourPaymentWasCancelled = 'yourPaymentWasCancelled',
		 YourPaymentWasDeclined = 'yourPaymentWasDeclined',
		 YourPreviouslyAddedCheckpoints = 'yourPreviouslyAddedCheckpoints',
		 YourPurchaseIsDefiniteAndCannotBeWithdrawn = 'yourPurchaseIsDefiniteAndCannotBeWithdrawn',
		 YourSubscripionIsExpired = 'yourSubscripionIsExpired',
		 YourSubscriptionHasExpired = 'yourSubscriptionHasExpired',
		 YourSubscriptionIsValidOnlyFor = 'yourSubscriptionIsValidOnlyFor',
		 YourSubscriptionWillBeValidUntil = 'yourSubscriptionWillBeValidUntil',
		 YourSubscriptionWillExpireInDays = 'yourSubscriptionWillExpireInDays',
		 YourSubscriptionWillExpireToday = 'yourSubscriptionWillExpireToday',
		 YourSubscriptionWillExpireTomorrow = 'yourSubscriptionWillExpireTomorrow',
		 YouWillReceiveAnEmailWithTheInvoice = 'youWillReceiveAnEmailWithTheInvoice',
		 Zipcode = 'zipcode',
		 ZipcodeNameIs = 'zipcodeNameIs',
	}


